webpackJsonp([2],{

/***/ "+q4l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase__ = __webpack_require__("J1c9");


var db = __WEBPACK_IMPORTED_MODULE_0__firebase__["a" /* default */].firestore();

/* harmony default export */ __webpack_exports__["a"] = ({
    get: function get(cb) {
        db.collection('users').onSnapshot(function (snap) {
            var users = [];
            snap.forEach(function (doc) {
                var data = doc.data();
                data.id = doc.id;
                users.push(data);
            });
            cb(users);
        });
    },
    changeRole: function changeRole(user) {

        db.collection('users').doc(user.id).update({
            role: user.role
        }).then(function () {
            console.log("Document successfully updated!");
        }).catch(function (error) {
            // The document probably doesn't exist.
            console.error("Error updating document: ", error);
        });
    }
});

/***/ }),

/***/ "/DJC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserOverview_vue__ = __webpack_require__("5CaS");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55f620d8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserOverview_vue__ = __webpack_require__("ZfKz");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserOverview_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55f620d8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserOverview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/yRs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js__ = __webpack_require__("diQi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js__) if(["default","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5f5650e6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_streetViewPanorama_vue__ = __webpack_require__("vaPR");
function injectStyle (ssrContext) {
  __webpack_require__("lk2w")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5f5650e6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_streetViewPanorama_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "0eij":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',[_c('v-flex',{attrs:{"xs12":"","sm6":"","offset-sm3":""}},[_c('v-card',[_c('v-card-media',{attrs:{"src":"/static/banner.jpg","height":"200px"}}),_vm._v(" "),_c('v-card-title',{attrs:{"primary-title":""}},[_vm._v("\n            "+_vm._s(_vm.message)+"\n            "),_c('v-form',{staticStyle:{"width":"100%"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-text-field',{attrs:{"label":"Email","required":""},model:{value:(_vm.creds.email),callback:function ($$v) {_vm.$set(_vm.creds, "email", $$v)},expression:"creds.email"}}),_vm._v(" "),_c('v-text-field',{attrs:{"type":"password","label":"Password","required":""},model:{value:(_vm.creds.password),callback:function ($$v) {_vm.$set(_vm.creds, "password", $$v)},expression:"creds.password"}})],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{staticStyle:{"width":"100%"},attrs:{"color":"primary"},on:{"click":function($event){return _vm.login()}}},[_vm._v("login")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0hj2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-map-container"},[_c('div',{ref:"vue-map",staticClass:"vue-map"}),_vm._v(" "),_c('div',{staticClass:"vue-map-hidden"},[_vm._t("default")],2),_vm._v(" "),_vm._t("visible")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0xgJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2Mmo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__firebase__ = __webpack_require__("J1c9");



var db = __WEBPACK_IMPORTED_MODULE_1__firebase__["a" /* default */].firestore();

/* harmony default export */ __webpack_exports__["a"] = ({
    add: function add(payload) {
        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
            db.collection('car_locations').doc(payload.email).set(payload);
        });
    },
    get: function get(cb) {
        db.collection('car_locations').onSnapshot(function (snap) {
            var cars = [];
            var time = new Date().getTime() / 1000;
            snap.forEach(function (doc) {
                var data = doc.data();
                data.id = doc.id;
                if (time < data.time / 1000 + 1800) cars.push(data);
            });
            cb(cars);
        });
    }
});

/***/ }),

/***/ "2xN/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FoxOverview_vue__ = __webpack_require__("wauf");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5369b744_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FoxOverview_vue__ = __webpack_require__("7k5U");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FoxOverview_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5369b744_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FoxOverview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3GDu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Map_vue__ = __webpack_require__("fGNU");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10aca8d0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Map_vue__ = __webpack_require__("xDxW");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Map_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10aca8d0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Map_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4Teq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('span',{domProps:{"textContent":_vm._s(_vm.label)}}),_vm._v(" "),_c('input',{ref:"input",class:_vm.className,attrs:{"type":"text","placeholder":_vm.placeholder}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4kNO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PoiOverview_vue__ = __webpack_require__("AQ1v");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ad3ff738_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PoiOverview_vue__ = __webpack_require__("Bo6+");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PoiOverview_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ad3ff738_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PoiOverview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5CaS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AddUserModal__ = __webpack_require__("K4W9");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'user-overview',
  mounted: function mounted() {
    this.$store.dispatch('RETRIEVE_USERS');
  },
  data: function data() {
    return {
      roles: [{ text: 'Geblokkeerd', value: 0 }, { text: 'Gebruiker', value: 10 }, { text: 'Administrator', value: 99 }],
      headers: [{ text: 'Naam', align: 'left', sortable: false }, { text: 'Email', align: 'left', sortable: false }, { text: 'Telefoon', align: 'left', sortable: false }, { text: 'Rol', align: 'left', sortable: false }],
      addUserOpen: false
    };
  },

  computed: {
    users: function users() {
      return this.$store.getters.users;
    }
  },
  methods: {
    changeRole: function changeRole(user, newRole) {
      this.$store.dispatch('CHANGE_USER_ROLE', { id: user.id, role: newRole });
    },
    openAddUser: function openAddUser() {
      this.addUserOpen = true;
    },
    closeAddUser: function closeAddUser() {
      this.addUserOpen = false;
    }
  },
  components: {
    AddUserModal: __WEBPACK_IMPORTED_MODULE_0__components_AddUserModal__["a" /* default */]
  }
});

/***/ }),

/***/ "5ZbH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js__ = __webpack_require__("kXiA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js__) if(["default","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_fb581256_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_map_vue__ = __webpack_require__("0hj2");
function injectStyle (ssrContext) {
  __webpack_require__("FFvd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_fb581256_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_map_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "5cLx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js__ = __webpack_require__("Vj7G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js__) if(["default","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_b1ade17a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_infoWindow_vue__ = __webpack_require__("Nk69");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_b1ade17a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_infoWindow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "7k5U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('fox-location-history-table',{attrs:{"fox":"alpha"}}),_vm._v(" "),_c('fox-location-history-table',{attrs:{"fox":"bravo"}}),_vm._v(" "),_c('fox-location-history-table',{attrs:{"fox":"charlie"}}),_vm._v(" "),_c('fox-location-history-table',{attrs:{"fox":"delta"}}),_vm._v(" "),_c('fox-location-history-table',{attrs:{"fox":"echo"}}),_vm._v(" "),_c('fox-location-history-table',{attrs:{"fox":"foxtrot"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "AQ1v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'poi-overview',
    mounted: function mounted() {
        this.$store.dispatch('RETRIEVE_POIS');
    },
    data: function data() {
        return {
            headers: [{ text: 'Omschrijving', align: 'left', sortable: false }, { text: 'Latitude', align: 'left', sortable: false }, { text: 'Latitude', align: 'left', sortable: false }, { text: '', align: 'right', sortable: false }]
        };
    },

    computed: {
        pois: function pois() {
            return this.$store.getters.pois;
        }
    },
    methods: {
        remove_poi: function remove_poi(poi) {
            this.$store.dispatch('REMOVE_POI', poi);
        }
    }
});

/***/ }),

/***/ "B2NC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc__ = __webpack_require__("INCx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'countdown-bar',
    data: function data() {
        return {
            now: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()(new Date().getTime() / 1000)
        };
    },
    mounted: function mounted() {
        var _this = this;

        window.setInterval(function () {
            _this.now = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()(new Date().getTime() / 1000);
        }, 10000);
    },

    computed: {
        alpha: function alpha() {
            var fox = this.$store.getters.hunt_alpha;
            if (fox == null) return 0;
            var date = fox.time / 1000 + 3600;
            var timer = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()((date - this.now) / 60) % 60;
            return timer < 0 ? 0 : timer;
        },
        bravo: function bravo() {
            var fox = this.$store.getters.hunt_bravo;
            if (fox == null) return 0;
            var date = fox.time / 1000 + 3600;
            var timer = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()((date - this.now) / 60) % 60;
            return timer < 0 ? 0 : timer;
        },
        charlie: function charlie() {
            var fox = this.$store.getters.hunt_charlie;
            if (fox == null) return 0;
            var date = fox.time / 1000 + 3600;
            var timer = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()((date - this.now) / 60) % 60;
            return timer < 0 ? 0 : timer;
        },
        delta: function delta() {
            var fox = this.$store.getters.hunt_delta;
            if (fox == null) return 0;
            var date = fox.time / 1000 + 3600;
            var timer = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()((date - this.now) / 60) % 60;
            return timer < 0 ? 0 : timer;
        },
        echo: function echo() {
            var fox = this.$store.getters.hunt_echo;
            if (fox == null) return 0;
            var date = fox.time / 1000 + 3600;
            var timer = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()((date - this.now) / 60) % 60;
            return timer < 0 ? 0 : timer;
        },
        foxtrot: function foxtrot() {
            var fox = this.$store.getters.hunt_foxtrot;
            if (fox == null) return 0;
            var date = fox.time / 1000 + 3600;
            var timer = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()((date - this.now) / 60) % 60;
            return timer < 0 ? 0 : timer;
        }
    }
});

/***/ }),

/***/ "Bo6+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.pois,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.description))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.lat))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.lng))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_c('a',{on:{"click":function($event){return _vm.remove_poi(props.item)}}},[_c('v-icon',[_vm._v("delete_forever")])],1)])]}}])},[_vm._v("pois\n      ")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "D+VX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_AuthService__ = __webpack_require__("SGRL");



var _mutations, _actions;



var AUTH_LOGIN = 'AUTH_LOGIN';
var AUTH_LOGIN_SUCCESS = 'AUTH_LOGIN_SUCCESS';
var AUTH_SET_USER = 'AUTH_SET_USER';

var auth = {
    state: {
        pending: false,
        user: null
    },
    mutations: (_mutations = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, AUTH_LOGIN, function (state) {
        state.pending = true;
    }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, AUTH_LOGIN_SUCCESS, function (state) {
        state.pending = false;
    }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, AUTH_SET_USER, function (state, user) {
        state.user = user;
    }), _mutations),
    actions: (_actions = {
        init: function init(_ref) {
            var commit = _ref.commit;

            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_2__services_AuthService__["a" /* default */].init().then(function (user) {
                    commit(AUTH_SET_USER, user);
                    resolve();
                }).catch(function () {
                    reject();
                });
            });
        },
        login: function login(_ref2, creds) {
            var commit = _ref2.commit;

            commit(AUTH_LOGIN);
            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_2__services_AuthService__["a" /* default */].login(creds).then(function () {
                    commit(AUTH_LOGIN_SUCCESS);
                    resolve();
                }).catch(function (error) {
                    reject(error);
                });
            });
        }
    }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, 'REGISTER_USER', function REGISTER_USER(_ref3, payload) {
        var commit = _ref3.commit;

        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
            __WEBPACK_IMPORTED_MODULE_2__services_AuthService__["a" /* default */].register(payload).then(function () {
                resolve();
            });
        });
    }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, 'logout', function logout(_ref4) {
        var commit = _ref4.commit;

        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
            __WEBPACK_IMPORTED_MODULE_2__services_AuthService__["a" /* default */].logout().then(function () {
                commit(AUTH_SET_USER, null);
                resolve();
            });
        });
    }), _actions),
    getters: {
        user: function user(state) {
            return state.user;
        }
    }
};

/* harmony default export */ __webpack_exports__["a"] = (auth);

/***/ }),

/***/ "EJT+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-toolbar',{staticClass:"primary",attrs:{"dark":""}},[_c('v-toolbar-title',{staticClass:"white--text"},[_vm._v("Zwerverhunt")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){return _vm.$router.push('/')}}},[_c('v-icon',{staticClass:"white--text"},[_vm._v("map")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){return _vm.$router.push('/settings')}}},[_c('v-icon',{staticClass:"white--text"},[_vm._v("settings")])],1),_vm._v(" "),(_vm.user.role == 99)?_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){return _vm.$router.push('/foxes')}}},[_c('v-icon',{staticClass:"white--text"},[_vm._v("pets")])],1):_vm._e(),_vm._v(" "),(_vm.user.role == 99)?_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){return _vm.$router.push('/pois')}}},[_c('v-icon',{staticClass:"white--text"},[_vm._v("local_activity")])],1):_vm._e(),_vm._v(" "),(_vm.user.role == 99)?_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){return _vm.$router.push('/users')}}},[_c('v-icon',{staticClass:"white--text"},[_vm._v("group")])],1):_vm._e()],1),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "EWfp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("EZYi");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d75779f4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("EJT+");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d75779f4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "EZYi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  computed: {
    user: function user() {
      return this.$store.getters.user;
    }
  },
  methods: {
    logout: function logout() {
      var _this = this;

      this.$store.dispatch('logout').then(function () {
        _this.$router.push('/login');
      });
    }
  }
});

/***/ }),

/***/ "FFvd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "H7H4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{ref:"input",attrs:{"type":"text","placeholder":_vm.placeholder},domProps:{"value":_vm.value}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "H9K2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_GroupService__ = __webpack_require__("aqyG");



var groups = {
    state: {
        groups: []
    },
    mutations: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, 'SET_GROUPS', function SET_GROUPS(state, groups) {
        state.groups = groups;
    }),
    actions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, 'RETRIEVE_GROUPS', function RETRIEVE_GROUPS(_ref) {
        var commit = _ref.commit;

        __WEBPACK_IMPORTED_MODULE_1__services_GroupService__["a" /* default */].get(function (groups) {
            commit('SET_GROUPS', groups);
        });
    }),
    getters: {
        groups: function groups(state) {
            return state.groups;
        }
    }
};

/* harmony default export */ __webpack_exports__["a"] = (groups);

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_auth__ = __webpack_require__("D+VX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_foxes__ = __webpack_require__("LIEz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_poi__ = __webpack_require__("djRV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_users__ = __webpack_require__("xSZb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_cars__ = __webpack_require__("SNEK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_groups__ = __webpack_require__("H9K2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_settings__ = __webpack_require__("THyH");











__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_0_vuex__["a" /* default */]);

var AUTH_LOGIN = 'AUTH_LOGIN';
var AUTH_LOGIN_SUCCESS = 'AUTH_LOGIN_SUCCESS';
var AUTH_SET_USER = 'AUTH_SET_USER';

var store = new __WEBPACK_IMPORTED_MODULE_0_vuex__["a" /* default */].Store({
    modules: {
        auth: __WEBPACK_IMPORTED_MODULE_2__modules_auth__["a" /* default */],
        foxes: __WEBPACK_IMPORTED_MODULE_3__modules_foxes__["a" /* default */],
        poi: __WEBPACK_IMPORTED_MODULE_4__modules_poi__["a" /* default */],
        users: __WEBPACK_IMPORTED_MODULE_5__modules_users__["a" /* default */],
        cars: __WEBPACK_IMPORTED_MODULE_6__modules_cars__["a" /* default */],
        groups: __WEBPACK_IMPORTED_MODULE_7__modules_groups__["a" /* default */],
        settings: __WEBPACK_IMPORTED_MODULE_8__modules_settings__["a" /* default */]
    }
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ "J1c9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__("Sazm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_firestore__ = __webpack_require__("3VHS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_firestore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase_firestore__);



var config = {
  apiKey: "AIzaSyB2o9EnTc6ETFPxh_FE98eCT_AlqMCbnZU",
  authDomain: "zwerverhunt-69c09.firebaseapp.com",
  databaseURL: "https://zwerverhunt-69c09.firebaseio.com",
  projectId: "zwerverhunt-69c09",
  storageBucket: "zwerverhunt-69c09.appspot.com",
  messagingSenderId: "142801624378",
  timestampsInSnapshots: true
};
__WEBPACK_IMPORTED_MODULE_0_firebase___default.a.initializeApp(config);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_firebase___default.a);

/***/ }),

/***/ "JZSy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'settings',
    computed: {
        settings: function settings() {
            return this.$store.getters.settings;
        }
    },
    methods: {
        changeFoxSetting: function changeFoxSetting(e) {
            this.$store.commit('SET_SETTING_FOX', e);
        },
        changeFoxCircleSetting: function changeFoxCircleSetting(e) {
            this.$store.commit('SET_SETTING_FOX_CIRCLE', e);
        },
        changeFoxPathSetting: function changeFoxPathSetting(e) {
            this.$store.commit('SET_SETTING_FOX_PATH', e);
        },
        changeCarsSetting: function changeCarsSetting(e) {
            this.$store.commit('SET_SETTING_CARS', e);
        },
        changeGroupsSetting: function changeGroupsSetting(e) {
            this.$store.commit('SET_SETTING_GROUPS', e);
        },
        changeZonesSetting: function changeZonesSetting(e) {
            this.$store.commit('SET_SETTING_ZONES', e);
        },
        changePoisSetting: function changePoisSetting(e) {
            this.$store.commit('SET_SETTING_POIS', e);
        },
        changeBaseCircleSetting: function changeBaseCircleSetting(e) {
            this.$store.commit('SET_SETTING_BASE_CIRCLE', e);
        }
    }
});

/***/ }),

/***/ "K4W9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddUserModal_vue__ = __webpack_require__("cA4l");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8a4ce37a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddUserModal_vue__ = __webpack_require__("zdjR");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddUserModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8a4ce37a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddUserModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KOE2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',[_c('v-switch',{attrs:{"label":"Vos"},on:{"change":_vm.changeFoxSetting},model:{value:(_vm.settings.fox),callback:function ($$v) {_vm.$set(_vm.settings, "fox", $$v)},expression:"settings.fox"}}),_vm._v(" "),_c('v-switch',{attrs:{"label":"Vos Cirkel"},on:{"change":_vm.changeFoxCircleSetting},model:{value:(_vm.settings.foxCircle),callback:function ($$v) {_vm.$set(_vm.settings, "foxCircle", $$v)},expression:"settings.foxCircle"}}),_vm._v(" "),_c('v-switch',{attrs:{"label":"Vos Pad"},on:{"change":_vm.changeFoxPathSetting},model:{value:(_vm.settings.foxPath),callback:function ($$v) {_vm.$set(_vm.settings, "foxPath", $$v)},expression:"settings.foxPath"}}),_vm._v(" "),_c('v-switch',{attrs:{"label":"Honken"},on:{"change":_vm.changeGroupsSetting},model:{value:(_vm.settings.groups),callback:function ($$v) {_vm.$set(_vm.settings, "groups", $$v)},expression:"settings.groups"}}),_vm._v(" "),_c('v-switch',{attrs:{"label":"Honk cirkel"},on:{"change":_vm.changeBaseCircleSetting},model:{value:(_vm.settings.baseCircle),callback:function ($$v) {_vm.$set(_vm.settings, "baseCircle", $$v)},expression:"settings.baseCircle"}}),_vm._v(" "),_c('v-switch',{attrs:{"label":"Deelgebieden"},on:{"change":_vm.changeZonesSetting},model:{value:(_vm.settings.zones),callback:function ($$v) {_vm.$set(_vm.settings, "zones", $$v)},expression:"settings.zones"}}),_vm._v(" "),_c('v-switch',{attrs:{"label":"Point of Interest"},on:{"change":_vm.changePoisSetting},model:{value:(_vm.settings.pois),callback:function ($$v) {_vm.$set(_vm.settings, "pois", $$v)},expression:"settings.pois"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LBOl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'AddFoxModal',
    data: function data() {
        return {
            fox: 'Alpha',
            isHunt: false,
            time: null,
            date: null
        };
    },

    props: ['open', 'position', 'close'],
    methods: {
        save: function save() {
            var t = new Date(this.time).getTime() - 7200 * 1000;

            this.$store.dispatch('ADD_FOX_LOCATION', {
                fox: this.fox.toLowerCase(),
                lat: this.position.lat,
                lng: this.position.lng,
                isHunt: this.isHunt,
                time: new Date(t)
            });
            this.close();
        }
    },
    computed: {
        isOpen: function isOpen() {
            return this.open;
        }
    },
    watch: {
        isOpen: {
            handler: function handler(n, o) {
                var t = new Date().getTime() + 7200 * 1000;
                this.time = new Date(t).toUTCString();
            }
        }
    }
});

/***/ }),

/***/ "LIEz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_FoxService__ = __webpack_require__("Ldax");


var _actions;



var foxes = {
    state: {
        locations: []
    },
    mutations: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, 'SET_FOX_LOCATIONS', function SET_FOX_LOCATIONS(state, path) {
        state.locations = path;
    }),
    actions: (_actions = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, 'RETRIEVE_FOX_LOCATIONS', function RETRIEVE_FOX_LOCATIONS(_ref) {
        var commit = _ref.commit;

        __WEBPACK_IMPORTED_MODULE_1__services_FoxService__["a" /* default */].get('alpha', function (path) {
            commit('SET_FOX_LOCATIONS', path);
        });
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, 'ADD_FOX_LOCATION', function ADD_FOX_LOCATION(_ref2, payload) {
        var commit = _ref2.commit;

        __WEBPACK_IMPORTED_MODULE_1__services_FoxService__["a" /* default */].add(payload);
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, 'REMOVE_FOX_LOCATION', function REMOVE_FOX_LOCATION(_ref3, payload) {
        var commit = _ref3.commit;

        __WEBPACK_IMPORTED_MODULE_1__services_FoxService__["a" /* default */].remove(payload);
    }), _actions),
    getters: {
        alpha: function alpha(state) {
            return state.locations.filter(function (loc) {
                return loc.fox === "alpha";
            });
        },
        bravo: function bravo(state) {
            return state.locations.filter(function (loc) {
                return loc.fox === "bravo";
            });
        },
        charlie: function charlie(state) {
            return state.locations.filter(function (loc) {
                return loc.fox === "charlie";
            });
        },
        delta: function delta(state) {
            return state.locations.filter(function (loc) {
                return loc.fox === "delta";
            });
        },
        echo: function echo(state) {
            return state.locations.filter(function (loc) {
                return loc.fox === "echo";
            });
        },
        foxtrot: function foxtrot(state) {
            return state.locations.filter(function (loc) {
                return loc.fox === "foxtrot";
            });
        },
        hunt_alpha: function hunt_alpha(state, getters) {
            var fox = getters.alpha.find(function (loc) {
                return loc.isHunt == true;
            });
            return fox;
        },
        hunt_bravo: function hunt_bravo(state, getters) {
            var fox = getters.bravo.find(function (loc) {
                return loc.isHunt == true;
            });
            return fox;
        },
        hunt_charlie: function hunt_charlie(state, getters) {
            var fox = getters.charlie.find(function (loc) {
                return loc.isHunt == true;
            });
            return fox;
        },
        hunt_delta: function hunt_delta(state, getters) {
            var fox = getters.delta.find(function (loc) {
                return loc.isHunt == true;
            });
            return fox;
        },
        hunt_echo: function hunt_echo(state, getters) {
            var fox = getters.echo.find(function (loc) {
                return loc.isHunt == true;
            });
            return fox;
        },
        hunt_foxtrot: function hunt_foxtrot(state, getters) {
            var fox = getters.foxtrot.find(function (loc) {
                return loc.isHunt == true;
            });
            return fox;
        }
    }
};

/* harmony default export */ __webpack_exports__["a"] = (foxes);

/***/ }),

/***/ "Ldax":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__firebase__ = __webpack_require__("J1c9");



var db = __WEBPACK_IMPORTED_MODULE_1__firebase__["a" /* default */].firestore();

/* harmony default export */ __webpack_exports__["a"] = ({
    add: function add(payload) {
        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
            db.collection('fox_locations').add(payload).then(function (ref) {
                resolve(ref.id);
            }).catch(function (err) {
                console.log(err);
            });
        });
    },
    remove: function remove(location) {
        db.collection('fox_locations').doc(location.id).delete();
    },
    get: function get(fox, cb) {
        db.collection('fox_locations').orderBy("time", "desc").onSnapshot(function (snap) {
            var path = [];
            snap.forEach(function (doc) {
                var data = doc.data();
                data.id = doc.id;
                path.push(data);
            });
            cb(path);
        });
    }
});

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ff4bbd52_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("0xgJ");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ff4bbd52_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MbIb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FoxPosition_vue__ = __webpack_require__("kbv/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37f573c4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FoxPosition_vue__ = __webpack_require__("Pmna");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FoxPosition_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37f573c4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FoxPosition_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetify__ = __webpack_require__("3EgV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_moment__ = __webpack_require__("mjDs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue2_google_maps__ = __webpack_require__("sA6N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue2_google_maps__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.








__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_moment___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue2_google_maps__, {
  load: {
    key: 'AIzaSyBxn4o44Ur9bz_iEVHB_UDH2kw9YU9uHCw',
    libraries: 'places'
  }
});

__webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "7zck"));

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ "Nk69":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"flyaway"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Okwi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":""},model:{value:(_vm.isOpen),callback:function ($$v) {_vm.isOpen=$$v},expression:"isOpen"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("POI Toevoegen")]),_vm._v(" "),_c('v-card-text',[_c('v-text-field',{attrs:{"label":"Latitude","required":""},model:{value:(_vm.position.lat),callback:function ($$v) {_vm.$set(_vm.position, "lat", $$v)},expression:"position.lat"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Longintude","required":""},model:{value:(_vm.position.lng),callback:function ($$v) {_vm.$set(_vm.position, "lng", $$v)},expression:"position.lng"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Omschrijving","required":""},model:{value:(_vm.description),callback:function ($$v) {_vm.description=$$v},expression:"description"}})],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"green--text darken-1",attrs:{"flat":"flat"},nativeOn:{"click":function($event){return _vm.close($event)}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{staticClass:"green--text darken-1",attrs:{"flat":"flat"},nativeOn:{"click":function($event){return _vm.save($event)}}},[_vm._v("Save")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "P+JY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.position)?_c('gmap-circle',{attrs:{"options":_vm.options,"center":_vm.position,"radius":_vm.radius}}):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Pmna":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.position)?_c('gmap-marker',{attrs:{"icon":_vm.image,"position":_vm.position},on:{"click":function($event){return _vm.onClick()}}}):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Q7ml":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FoxCircle_vue__ = __webpack_require__("ovGn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d3eca0ac_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FoxCircle_vue__ = __webpack_require__("P+JY");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FoxCircle_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d3eca0ac_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FoxCircle_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SGRL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__firebase__ = __webpack_require__("J1c9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase__ = __webpack_require__("Sazm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_firebase__);




var db = __WEBPACK_IMPORTED_MODULE_1__firebase__["a" /* default */].firestore();
var auth = __WEBPACK_IMPORTED_MODULE_1__firebase__["a" /* default */].auth();

var config = {
    apiKey: "AIzaSyB2o9EnTc6ETFPxh_FE98eCT_AlqMCbnZU",
    authDomain: "zwerverhunt-69c09.firebaseapp.com",
    databaseURL: "https://zwerverhunt-69c09.firebaseio.com"
};
var secondaryApp = __WEBPACK_IMPORTED_MODULE_1__firebase__["a" /* default */].initializeApp(config, "Secondary");

/* harmony default export */ __webpack_exports__["a"] = ({
    login: function login(creds) {
        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_1__firebase__["a" /* default */].auth().signInWithEmailAndPassword(creds.email, creds.password).then(function () {
                resolve();
            }).catch(function (error) {
                reject(error);
            });
        });
    },
    register: function register(user) {
        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            secondaryApp.auth().createUserWithEmailAndPassword(user.email, user.password).then(function (firebaseUser) {
                secondaryApp.auth().signOut();
                db.doc('users/' + firebaseUser.uid).set({
                    name: user.name,
                    email: user.email,
                    phone: user.phone,
                    role: user.role
                }).then(function (ref) {
                    resolve();
                }).catch(function (error) {
                    reject();
                });
            });
        });
    },
    init: function init() {
        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            auth.onAuthStateChanged(function (user) {
                if (user) {
                    db.doc("users/" + user.uid).get().then(function (doc) {
                        var user = {};
                        user = doc.data();
                        if (user.role > 0) resolve(user);else reject();
                    });
                } else {
                    reject();
                }
            });
        });
    },
    logout: function logout() {
        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
            __WEBPACK_IMPORTED_MODULE_1__firebase__["a" /* default */].auth().signOut().then(function () {
                resolve();
            });
        });
    }
});

/***/ }),

/***/ "SNEK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_CarService__ = __webpack_require__("2Mmo");


var _actions;



var cars = {
    state: {
        cars: []
    },
    mutations: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, 'SET_CARS', function SET_CARS(state, cars) {
        state.cars = cars;
    }),
    actions: (_actions = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, 'RETRIEVE_CARS', function RETRIEVE_CARS(_ref) {
        var commit = _ref.commit;

        __WEBPACK_IMPORTED_MODULE_1__services_CarService__["a" /* default */].get(function (cars) {
            commit('SET_CARS', cars);
        });
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, 'ADD_CAR_LOCATION', function ADD_CAR_LOCATION(_ref2, carLocation) {
        var commit = _ref2.commit;

        __WEBPACK_IMPORTED_MODULE_1__services_CarService__["a" /* default */].add(carLocation);
    }), _actions),
    getters: {
        cars: function cars(state) {
            return state.cars;
        }
    }
};

/* harmony default export */ __webpack_exports__["a"] = (cars);

/***/ }),

/***/ "THyH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);



var _mutations;

var loadState = function loadState() {
    try {
        var serializedState = localStorage.getItem('zwerverhunt_settings');
        if (serializedState === null) {
            return undefined;
        }
        var state = JSON.parse(serializedState);

        console.log(state.maps);
        if (state.maps != undefined || state.maps == null) {
            state.maps = {
                center: { lat: 52.0263, lng: 5.5544 },
                zoom: 9
            };
        }

        if (state.baseCircle != undefined || state.baseCircle == null) {
            state.baseCircle = false;
        }

        return state;
    } catch (err) {
        return undefined;
    }
};

var saveState = function saveState(state) {
    try {
        var serializedState = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(state);
        localStorage.setItem('zwerverhunt_settings', serializedState);
    } catch (err) {
        console.error('Something went wrong: ' + err);
    }
};

var settings = {
    state: loadState() || {
        foxCircle: true,
        foxPath: true,
        fox: true,
        groups: true,
        cars: true,
        pois: false,
        zones: true,
        baseCircle: false,
        maps: {
            center: { lat: 52.0263, lng: 5.5544 },
            zoom: 9
        }
    },
    mutations: (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'SET_SETTING_FOX', function SET_SETTING_FOX(state, status) {
        state.fox = status;
        saveState(state);
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'SET_SETTING_FOX_CIRCLE', function SET_SETTING_FOX_CIRCLE(state, status) {
        state.foxCircle = status;
        saveState(state);
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'SET_SETTING_FOX_PATH', function SET_SETTING_FOX_PATH(state, status) {
        state.foxPath = status;
        saveState(state);
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'SET_SETTING_GROUPS', function SET_SETTING_GROUPS(state, status) {
        state.groups = status;
        saveState(state);
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'SET_SETTING_CARS', function SET_SETTING_CARS(state, status) {
        state.cars = status;
        saveState(state);
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'SET_SETTING_FOX_POIS', function SET_SETTING_FOX_POIS(state, status) {
        state.pois = status;
        saveState(state);
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'SET_SETTING_FOX_ZONES', function SET_SETTING_FOX_ZONES(state, status) {
        state.zones = status;
        saveState(state);
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'SET_SETTING_MAP_CENTER', function SET_SETTING_MAP_CENTER(state, location) {
        state.maps.center = location;
        saveState(state);
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'SET_SETTING_MAP_ZOOM', function SET_SETTING_MAP_ZOOM(state, zoom) {
        state.maps.zoom = zoom;
        saveState(state);
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'SET_SETTING_BASE_CIRCLE', function SET_SETTING_BASE_CIRCLE(state, val) {
        state.baseCircle = val;
        saveState(state);
    }), _mutations),
    getters: {
        settings: function settings(state) {
            return state;
        }
    }
};

/* harmony default export */ __webpack_exports__["a"] = (settings);

/***/ }),

/***/ "V6q9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":""},model:{value:(_vm.isOpen),callback:function ($$v) {_vm.isOpen=$$v},expression:"isOpen"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Vos Toevoegen")]),_vm._v(" "),_c('v-card-text',[_c('v-select',{attrs:{"label":"Vos","items":['Alpha', 'Bravo', 'Charlie', 'Delta', 'Echo', 'Foxtrot'],"required":""},model:{value:(_vm.fox),callback:function ($$v) {_vm.fox=$$v},expression:"fox"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Latitude","required":""},model:{value:(_vm.position.lat),callback:function ($$v) {_vm.$set(_vm.position, "lat", $$v)},expression:"position.lat"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Longintude","required":""},model:{value:(_vm.position.lng),callback:function ($$v) {_vm.$set(_vm.position, "lng", $$v)},expression:"position.lng"}}),_vm._v(" "),_c('v-checkbox',{attrs:{"label":"Hunt","required":""},model:{value:(_vm.isHunt),callback:function ($$v) {_vm.isHunt=$$v},expression:"isHunt"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Tijd","required":""},model:{value:(_vm.time),callback:function ($$v) {_vm.time=$$v},expression:"time"}},[_vm._v("HELLO")])],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"green--text darken-1",attrs:{"flat":"flat"},nativeOn:{"click":function($event){return _vm.close($event)}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{staticClass:"green--text darken-1",attrs:{"flat":"flat"},nativeOn:{"click":function($event){return _vm.save($event)}}},[_vm._v("Save")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YI6p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__ = __webpack_require__("jIen");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__) if(["default","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_13bfbbee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_placeInput_vue__ = __webpack_require__("4Teq");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_13bfbbee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_placeInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_App__ = __webpack_require__("EWfp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Login__ = __webpack_require__("xJsL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Settings__ = __webpack_require__("niH5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_UserOverview__ = __webpack_require__("/DJC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_FoxOverview__ = __webpack_require__("2xN/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_PoiOverview__ = __webpack_require__("4kNO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Car__ = __webpack_require__("lTUX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Map__ = __webpack_require__("3GDu");













__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    beforeEnter: function beforeEnter(to, from, next) {
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('init').then(function () {
        next();
      }).catch(function () {
        next('/login');
      });
    },
    component: __WEBPACK_IMPORTED_MODULE_3__components_App__["a" /* default */],
    children: [{ path: '/', name: 'map', component: __WEBPACK_IMPORTED_MODULE_10__components_Map__["a" /* default */] }, { path: '/settings', name: 'settings', component: __WEBPACK_IMPORTED_MODULE_5__components_Settings__["a" /* default */] }, { path: '/users', name: 'user-overview', component: __WEBPACK_IMPORTED_MODULE_6__components_UserOverview__["a" /* default */] }, { path: '/foxes', name: 'fox-overview', component: __WEBPACK_IMPORTED_MODULE_7__components_FoxOverview__["a" /* default */] }, { path: '/pois', name: 'poi-overview', component: __WEBPACK_IMPORTED_MODULE_8__components_PoiOverview__["a" /* default */] }]
  }, { path: '/login', name: 'login', component: __WEBPACK_IMPORTED_MODULE_4__components_Login__["a" /* default */] }, { path: '/car', name: 'car', component: __WEBPACK_IMPORTED_MODULE_9__components_Car__["a" /* default */] }]
}));

/***/ }),

/***/ "ZfKz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-btn',{staticStyle:{"position":"relative","float":"right"},attrs:{"fab":"","dark":"","color":"indigo"},on:{"click":_vm.openAddUser}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("add")])],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.users,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.email))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.phone))]),_vm._v(" "),_c('td',[_c('v-select',{attrs:{"items":_vm.roles,"item-text":"text","item-value":"value","label":"Select","single-line":"","bottom":""},on:{"change":function($event){return _vm.changeRole(props.item, $event)}},model:{value:(props.item.role),callback:function ($$v) {_vm.$set(props.item, "role", $$v)},expression:"props.item.role"}})],1)]}}])}),_vm._v(" "),_c('add-user-modal',{attrs:{"open":_vm.addUserOpen,"close":_vm.closeAddUser}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aqyG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var groups = [{ "plaats": null, "naam": "Jotihunt HQ", "lat": 51.9538656, "lng": 5.8723984, "regio": null }, { "plaats": null, "naam": "Scouting Beuningen '76", "lat": 51.853591, "lng": 5.782183, "regio": null }, { "plaats": null, "naam": "Verbraak Margriet Goep", "lat": 52.324744, "lng": 5.6356, "regio": null }, { "plaats": null, "naam": "H\xE9l\xE8ne H. Wilkensgroep - Scouting Voorst", "lat": 52.182118, "lng": 6.139318, "regio": null }, { "plaats": null, "naam": "Scouting Ragay Redoz", "lat": 52.326292, "lng": 5.63389, "regio": null }, { "plaats": null, "naam": "Scouting Bemmel", "lat": 51.887226, "lng": 5.905355, "regio": null }, { "plaats": null, "naam": "Scouting Sint Joris Zutphen", "lat": 52.187361, "lng": 6.224386, "regio": null }, { "plaats": null, "naam": "Scouting De Rietkampers en Scouting Don Bosco", "lat": 51.882071, "lng": 5.615894, "regio": null }, { "plaats": null, "naam": "Subanhara Liemersgroep", "lat": 51.915813, "lng": 6.0661, "regio": null }, { "plaats": null, "naam": "Scouting Roothaangroep", "lat": 51.949331, "lng": 6.3200140000000005, "regio": null }, { "plaats": null, "naam": "Scouting Graaf Ottogroep + Jan van Riebeeck + Ulft", "lat": 51.882017, "lng": 6.387111, "regio": null }, { "plaats": null, "naam": "Scouting Paul Kruger", "lat": 51.825699, "lng": 5.890989, "regio": null }, { "plaats": null, "naam": "Scouting Dieren", "lat": 52.054173, "lng": 6.076759, "regio": null }, { "plaats": null, "naam": "Scouting Hamaland", "lat": 51.976407, "lng": 6.267348, "regio": null }, { "plaats": null, "naam": "Scouting Woezik", "lat": 51.825154, "lng": 5.717446, "regio": null }, { "plaats": null, "naam": "Karmijngroep Winssen", "lat": 51.881465, "lng": 5.700388, "regio": null }, { "plaats": null, "naam": "Aerendheem", "lat": 52.004355, "lng": 5.947895, "regio": null }, { "plaats": null, "naam": "Scouting Isala Doesburg", "lat": 52.007958, "lng": 6.146011, "regio": null }, { "plaats": null, "naam": " Scouting de Paulus Dreumel", "lat": 51.848643, "lng": 5.432334, "regio": null }, { "plaats": null, "naam": "Alexandergroep Ermelo", "lat": 52.286734, "lng": 5.594552, "regio": null }, { "plaats": null, "naam": "De Zwervers", "lat": 52.015291, "lng": 5.536122, "regio": null }, { "plaats": null, "naam": "Scouting Langenberggroep Ede", "lat": 52.040356, "lng": 5.690757, "regio": null }, { "plaats": null, "naam": "Scouting Saksenheerd", "lat": 51.874248, "lng": 6.463857, "regio": null }, { "plaats": null, "naam": "Irmin-Taweb", "lat": 52.3154, "lng": 5.620175, "regio": null }, { "plaats": null, "naam": "Scouting Groessen en Scouting Zeddam", "lat": 51.931909, "lng": 6.032336, "regio": null }, { "plaats": null, "naam": "Scoutinggroep de Bevers / Scouting Malden", "lat": 51.809033, "lng": 5.789709, "regio": null }, { "plaats": null, "naam": "Scouting Olivier van Noort", "lat": 51.993176, "lng": 5.820465, "regio": null }, { "plaats": null, "naam": "Scouting Valeouwe", "lat": 52.122281, "lng": 6.028039, "regio": null }, { "plaats": null, "naam": "Scouting St. Franciscus", "lat": 51.805696, "lng": 5.744995, "regio": null }, { "plaats": null, "naam": "Rhedense Pioniers", "lat": 52.006231, "lng": 6.028053, "regio": null }, { "plaats": null, "naam": "Scouting Kontiki", "lat": 52.244528, "lng": 5.639806, "regio": null }, { "plaats": null, "naam": "Scouting Graaf van Gerle", "lat": 51.877678, "lng": 5.2713, "regio": null }, { "plaats": null, "naam": "Scouting Karel de Stoute", "lat": 51.801604, "lng": 5.817912, "regio": null }, { "plaats": null, "naam": "SBV/Kastanjegroep, Lincolngroep en Anne de Guign\xE9", "lat": 51.992236, "lng": 5.888899, "regio": null }, { "plaats": null, "naam": "St Willibrordgroep Didam", "lat": 51.938537, "lng": 6.132168, "regio": null }, { "plaats": null, "naam": "Scouting Gaanderen & Scouting Gendringen", "lat": 51.870251, "lng": 6.371148, "regio": null }, { "plaats": null, "naam": "St. Christoforus - Lichtdraagsters", "lat": 51.99615, "lng": 5.931669, "regio": null }, { "plaats": null, "naam": "Scouting Tarcisius Ede", "lat": 52.051333, "lng": 5.678422, "regio": null }, { "plaats": null, "naam": "Schutgraaf", "lat": 51.966187, "lng": 5.869682, "regio": null }, { "plaats": null, "naam": "Scouting Nijkerk", "lat": 52.224174, "lng": 5.455871, "regio": null }, { "plaats": null, "naam": "Scouting Mgr. de la Geneste Grave en Scounting Boxmeer", "lat": 51.765314000000004, "lng": 5.829363, "regio": null }, { "plaats": null, "naam": "Scouting Lido 76 & Voermangroep", "lat": 51.968325, "lng": 5.917514, "regio": null }, { "plaats": null, "naam": "Scouting Valburg", "lat": 51.907504, "lng": 5.794226, "regio": null }, { "plaats": null, "naam": "De Geuzen", "lat": 51.987625, "lng": 5.8762, "regio": null }, { "plaats": null, "naam": "Scouting Duiven", "lat": 51.943987, "lng": 6.03232, "regio": null }, { "plaats": null, "naam": "Scouting Nunspeet", "lat": 52.376162, "lng": 5.806682, "regio": null }, { "plaats": null, "naam": "St.Werenfridusgroep", "lat": 51.906629, "lng": 5.843221, "regio": null }, { "plaats": null, "naam": "Scouting Weurt", "lat": 51.859154, "lng": 5.817234, "regio": null }, { "plaats": null, "naam": "Scouting Zetten", "lat": 51.932593, "lng": 5.709315, "regio": null }, { "plaats": null, "naam": "Scouting Bennekom", "lat": 52.010021, "lng": 5.686948, "regio": null }, { "plaats": null, "naam": "Scouting Lunteren", "lat": 52.091534, "lng": 5.650855, "regio": null }, { "plaats": null, "naam": "St Stanislaus & Saffatin", "lat": 51.959888, "lng": 5.216696, "regio": null }, { "plaats": null, "naam": "Stadhouder Willem III/Lady Baden-Powell", "lat": 52.225696, "lng": 5.943067, "regio": null }, { "plaats": null, "naam": "Scoutinggroep De Markesteen", "lat": 52.016031, "lng": 5.98433, "regio": null }, { "plaats": null, "naam": "Scouting Titus Brandsma Deventer", "lat": 52.250597, "lng": 6.212575, "regio": null }, { "plaats": null, "naam": "Velpsche Woudloopers en de Olmen", "lat": 52.008434, "lng": 5.9788879999999995, "regio": null }, { "plaats": null, "naam": "Scouting IJsselgroep en Scouting Kompasnaald", "lat": 52.199177, "lng": 6.21412, "regio": null }, { "plaats": null, "naam": "Scouting Dannenburcht", "lat": 51.935662, "lng": 5.942214, "regio": null }, { "plaats": null, "naam": "Gustaaf Adolfgroep", "lat": 52.408375, "lng": 5.864122, "regio": null }, { "plaats": null, "naam": "Scouting Amalgama", "lat": 51.839158, "lng": 5.7856, "regio": null }, { "plaats": null, "naam": "Scoutinggroep JJB", "lat": 52.196468, "lng": 5.922747, "regio": null }, { "plaats": null, "naam": "Scouting Jan Hilgers Ede", "lat": 52.041743, "lng": 5.619772, "regio": null }, { "plaats": null, "naam": "Scouting Phoenix Tiel", "lat": 51.899777, "lng": 5.426503, "regio": null }, { "plaats": null, "naam": "Scouting Hertog van Gelre", "lat": 52.184207, "lng": 6.0051, "regio": null }, { "plaats": null, "naam": "Scouting de Woutergroep Deest", "lat": 51.889036, "lng": 5.660139, "regio": null }, { "plaats": null, "naam": "Andr\xE9 de Thaye Arnhem", "lat": 51.981338, "lng": 5.93428, "regio": null }, { "plaats": null, "naam": "Scouting Jonko Silvolde", "lat": 51.910275, "lng": 6.381175, "regio": null }, { "plaats": null, "naam": "Jan Wandelaar", "lat": 52.306808, "lng": 5.528677, "regio": null }];
/* harmony default export */ __webpack_exports__["a"] = ({
    get: function get(cb) {
        cb(groups);
    }
});

/***/ }),

/***/ "b9Wf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'fox-location-history-table',
    props: ['fox'],
    data: function data() {
        return {
            headers: [{ text: 'Tijd', align: 'left', sortable: false }, { text: 'Latitude', align: 'left', sortable: false }, { text: 'Longitude', align: 'left', sortable: false }, { text: 'Hunt', align: 'left', sortable: false }, { text: '', align: 'right', sortable: false }]
        };
    },

    computed: {
        locations: function locations() {
            return this.$store.getters[this.fox];
        }
    },
    methods: {
        remove_location: function remove_location(location) {
            this.$store.dispatch('REMOVE_FOX_LOCATION', location);
        }
    }
});

/***/ }),

/***/ "bN8B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('h5',[_vm._v(_vm._s(_vm.fox))]),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.locations,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(_vm._f("moment")(props.item.time,"MMMM Do YYYY, h:mm:ss a")))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.lat))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.lng))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.isHunt))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_c('a',{on:{"click":function($event){return _vm.remove_location(props.item)}}},[_c('v-icon',[_vm._v("delete_forever")])],1)])]}}])},[_vm._v("pois\n    ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cA4l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'AddFoxModal',
    data: function data() {
        return {
            email: '',
            name: '',
            phone: '',
            password: ''
        };
    },

    props: ['open', 'close'],
    methods: {
        save: function save() {
            var _this = this;

            this.$store.dispatch('REGISTER_USER', {
                email: this.email,
                name: this.name,
                phone: this.phone,
                password: this.password,
                role: 10
            }).then(function () {
                _this.email = '';
                _this.name = '';
                _this.phone = '';
                _this.password = '';
                _this.close();
            });
        },
        closeModal: function closeModal() {
            this.email = '';
            this.name = '';
            this.phone = '';
            this.password = '';
            this.close();
        }
    }
});

/***/ }),

/***/ "cdT5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',[_c('h3',{staticClass:"text-xs-center"},[_vm._v("Tracker")]),_vm._v(" "),(_vm.user)?_c('h4',{staticClass:"text-xs-center"},[_vm._v(_vm._s(_vm.user.name))]):_vm._e(),_vm._v(" "),_c('v-layout',{staticStyle:{"margin-top":"25px"}},[_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs6":""}},[_c('h5',[_vm._v("Latitude")]),_vm._v(" "),_c('h6',[_vm._v(_vm._s(_vm.position.lat))])]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs6":""}},[_c('h5',[_vm._v("Longitude")]),_vm._v(" "),_c('h6',[_vm._v(_vm._s(_vm.position.lng))]),_c('p')])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "d7Nw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'AddFoxModal',
    data: function data() {
        return {
            description: ''
        };
    },

    props: ['open', 'position', 'close'],
    methods: {
        save: function save() {
            this.$store.dispatch('ADD_POI', {
                lat: this.position.lat,
                lng: this.position.lng,
                description: this.description
            });
            this.close();
        }
    },
    computed: {
        isOpen: function isOpen() {
            return this.open;
        }
    }
});

/***/ }),

/***/ "djRV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_PoiService__ = __webpack_require__("xyay");


var _actions;



var pois = {
    state: {
        pois: []
    },
    mutations: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, 'SET_POIS', function SET_POIS(state, pois) {
        state.pois = pois;
    }),
    actions: (_actions = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, 'RETRIEVE_POIS', function RETRIEVE_POIS(_ref) {
        var commit = _ref.commit;

        __WEBPACK_IMPORTED_MODULE_1__services_PoiService__["a" /* default */].get(function (pois) {
            commit('SET_POIS', pois);
        });
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, 'ADD_POI', function ADD_POI(_ref2, payload) {
        var commit = _ref2.commit;

        __WEBPACK_IMPORTED_MODULE_1__services_PoiService__["a" /* default */].add(payload);
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, 'REMOVE_POI', function REMOVE_POI(_ref3, payload) {
        var commit = _ref3.commit;

        console.log(payload);
        __WEBPACK_IMPORTED_MODULE_1__services_PoiService__["a" /* default */].remove(payload);
    }), _actions),
    getters: {
        pois: function pois(state) {
            return state.pois;
        }
    }
};

/* harmony default export */ __webpack_exports__["a"] = (pois);

/***/ }),

/***/ "dm2N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',{staticStyle:{"padding":"0px"}},[_c('v-layout',{staticClass:"text-xs-center"},[_c('v-flex',{attrs:{"xs2":""}},[_vm._v("\r\n            Alpha"),_c('br'),_vm._v(" "),_c('h6',[_vm._v(_vm._s(_vm.alpha))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_vm._v("Bravo"),_c('br'),_vm._v(" "),_c('h6',[_vm._v(_vm._s(_vm.bravo))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_vm._v("\r\n              Charlie"),_c('br'),_vm._v(" "),_c('h6',[_vm._v(_vm._s(_vm.charlie))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_vm._v("Delta"),_c('br'),_vm._v(" "),_c('h6',[_vm._v(_vm._s(_vm.delta))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_vm._v("Echo"),_c('br'),_vm._v(" "),_c('h6',[_vm._v(_vm._s(_vm.echo))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_vm._v("Foxtrot"),_c('br'),_vm._v(" "),_c('h6',[_vm._v(_vm._s(_vm.foxtrot))])])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "eooe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FoxPath_vue__ = __webpack_require__("yV3O");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d4f3920_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FoxPath_vue__ = __webpack_require__("iL7n");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FoxPath_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d4f3920_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FoxPath_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fGNU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_maps_FoxPath__ = __webpack_require__("eooe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_maps_FoxPosition__ = __webpack_require__("MbIb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_maps_FoxCircle__ = __webpack_require__("Q7ml");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_maps_CountdownBar__ = __webpack_require__("iXMs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_AddFoxModal__ = __webpack_require__("jcYF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_AddPoiModal__ = __webpack_require__("vaHE");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'map',
  data: function data() {
    return {
      actions_dial: false,
      click_location: { lat: null, lng: null },
      modals: {
        addFox: false,
        addPoi: false
      },
      polyOptions: {
        clickable: false,
        fillOpacity: 0.1,
        strokeWeight: 2,
        strokeOpacity: 0.3
      },
      action: null,
      info: {
        options: {
          pixelOffset: { width: 0, height: -35 }
        },
        content: '',
        position: { lat: null, lng: null },
        open: false
      }
    };
  },

  computed: {
    user: function user() {
      return this.$store.getters.user;
    },
    settings: function settings() {
      return this.$store.getters.settings;
    },
    pois: function pois() {
      return this.settings.pois && this.$store.getters.pois;
    },
    cars: function cars() {
      return this.settings.cars && this.$store.getters.cars;
    },
    groups: function groups() {
      return this.settings.groups && this.$store.getters.groups;
    },
    groupIcon: function groupIcon() {
      return {
        url: "static/logo.png", // url
        scaledSize: new google.maps.Size(25, 25)
      };
    },
    zones: function zones() {
      return {
        alpha: [[5.3173828125, 52.298821667009001, 0.0], [5.4036855697632, 52.246748056732002, 0.0], [5.393208861351, 52.220353097698997, 0.0], [5.406896173954, 52.213500459012003, 0.0], [5.4095542430878, 52.218558695934, 0.0], [5.420667976141, 52.213436364594997, 0.0], [5.4287776350975, 52.208602721745002, 0.0], [5.4362656921148, 52.205278362599003, 0.0], [5.4368014633656, 52.205583277099002, 0.0], [5.4395896196365, 52.204615104696998, 0.0], [5.4389016330242, 52.184048376728001, 0.0], [5.440032184124, 52.173300043060003, 0.0], [5.438441298902, 52.173016702574003, 0.0], [5.4402407258749, 52.169574937976002, 0.0], [5.4462109878659, 52.167769848291002, 0.0], [5.4550565779209, 52.167017603151997, 0.0], [5.4728865623474, 52.163903197643002, 0.0], [5.4731065034866, 52.162948925179002, 0.0], [5.4723823070526, 52.162889693799002, 0.0], [5.4726934432983, 52.161876166873, 0.0], [5.4754088446498, 52.162172329725998, 0.0], [5.4790254682302, 52.161652398077997, 0.0], [5.480346120894, 52.161013992683003, 0.0], [5.4807655513287, 52.160270271758002, 0.0], [5.4800204001367, 52.160066239951, 0.0], [5.4792323336005, 52.158466861450997, 0.0], [5.4802311211824, 52.157295263776, 0.0], [5.4827319458127, 52.158374714436, 0.0], [5.4842457175255, 52.158216747681998, 0.0], [5.4826404154301, 52.151568471867002, 0.0], [5.4812067747116, 52.150581019489998, 0.0], [5.4837746545672, 52.149451182531003, 0.0], [5.4872866719961, 52.148637320081001, 0.0], [5.4928800836205, 52.147783941758, 0.0], [5.4965565539896, 52.147291410759998, 0.0], [5.4989455640316, 52.147404565815002, 0.0], [5.4973724484444, 52.141462507829999, 0.0], [5.4998705908656, 52.141139046187, 0.0], [5.5021541565657, 52.139735705744002, 0.0], [5.5097682774067, 52.13824589419, 0.0], [5.5125115066767, 52.137098458395997, 0.0], [5.5139672756195, 52.135977334042003, 0.0], [5.5124035477638, 52.134298064166998, 0.0], [5.5123847723007, 52.132131383233997, 0.0], [5.5017015337944, 52.129740667711999, 0.0], [5.4979705810547, 52.130221455517997, 0.0], [5.4969352483749, 52.124899569881002, 0.0], [5.4963277280331, 52.124557050520998, 0.0], [5.4947331547737, 52.124741484349002, 0.0], [5.4951341450214, 52.122212039579999, 0.0], [5.4966864734888, 52.120525663309003, 0.0], [5.4963934421539, 52.119708801862998, 0.0], [5.5037480592728, 52.116678378624002, 0.0], [5.5074897408485, 52.115716505565999, 0.0], [5.5077981948853, 52.113884936468999, 0.0], [5.506320297718, 52.114313187782003, 0.0], [5.5038553476334, 52.113687280629001, 0.0], [5.5024203658104, 52.114972027923997, 0.0], [5.4987967014313, 52.116230385534998, 0.0], [5.4924935102463, 52.115769211477001, 0.0], [5.4892989993095, 52.116250150031, 0.0], [5.4862761497498, 52.115413445370997, 0.0], [5.4914286732674, 52.114458133448998, 0.0], [5.4941779375076, 52.11271216566, 0.0], [5.4936850816011, 52.110964482256001, 0.0], [5.4893298447132, 52.108584162343, 0.0], [5.4841384291649, 52.106406346587001, 0.0], [5.4848277568817, 52.093244936547002, 0.0], [5.476590692997, 52.090364330404, 0.0], [5.4719585180283, 52.089382113252, 0.0], [5.4638502001762, 52.083310344796999, 0.0], [5.4596672952175, 52.082014795408, 0.0], [5.4602795094252, 52.080997779274, 0.0], [5.4593467712402, 52.080349975715997, 0.0], [5.4917907714844, 52.000524113476999, 0.0], [5.6658554077148, 52.015317436634, 0.0], [5.8515930175781, 52.021233396705, 0.0], [5.9291839599609, 52.467305322032999, 0.0], [5.9118461608887, 52.496368550507, 0.0], [5.8780288696289, 52.521234766555999, 0.0], [5.8606910705566, 52.516638711003999, 0.0], [5.8561849594116, 52.545878132539002, 0.0], [5.8420658111572, 52.560907969365999, 0.0], [5.8073472976685, 52.581774203121, 0.0], [5.7588958740234, 52.581774203121, 0.0], [5.3173828125, 52.298821667009001, 0.0]].map(function (coords) {
          return { lat: coords[1], lng: coords[0] };
        }),
        bravo: [[5.9291839599609, 52.467305322032999, 0.0], [5.9355998039246, 52.477722724204, 0.0], [5.9571218490601, 52.483956301051997, 0.0], [5.9658336639404, 52.476768660719998, 0.0], [6.0217094421387, 52.509639248363001, 0.0], [6.0445189476013, 52.504062386024998, 0.0], [6.0588043928146, 52.49775654482, 0.0], [6.0669100284576, 52.483923632615998, 0.0], [6.0879278182983, 52.477997176991003, 0.0], [6.101907491684, 52.467468725669001, 0.0], [6.1021542549133, 52.444802117899997, 0.0], [6.1133015155792, 52.438504130570003, 0.0], [6.1186122894287, 52.432833209816003, 0.0], [6.1160038411617, 52.430502001192004, 0.0], [6.1183735728264, 52.427856653713, 0.0], [6.1173268407583, 52.424702063523, 0.0], [6.1133618652821, 52.419139376141999, 0.0], [6.114529967308, 52.414399312962999, 0.0], [6.1109626293182, 52.407792639093003, 0.0], [6.1302638053894, 52.399813573205002, 0.0], [6.1256048083305, 52.393707205902999, 0.0], [6.1255069077015, 52.384053297709997, 0.0], [6.1219757795334, 52.380475208924999, 0.0], [6.1178317666054, 52.378662723872999, 0.0], [6.1027195304632, 52.375380168284998, 0.0], [6.080397516489, 52.371678148381001, 0.0], [6.0776388645172, 52.368885155263001, 0.0], [6.0775288939476, 52.363927587470002, 0.0], [6.0803338140249, 52.361849485389001, 0.0], [6.0910351574421, 52.360819611388003, 0.0], [6.0945850610733, 52.356872699020002, 0.0], [6.0896377265453, 52.354183617003997, 0.0], [6.0785105824471, 52.352962295449998, 0.0], [6.0759081691504, 52.350647753474, 0.0], [6.0758832748979, 52.345344707930998, 0.0], [6.0750859044492, 52.344550663283002, 0.0], [6.0757905710489, 52.344464483464002, 0.0], [6.0753794386983, 52.341756467210999, 0.0], [6.0758909862489, 52.341762049019998, 0.0], [6.0766600258648, 52.339879812924003, 0.0], [6.0754978749901, 52.334824597248002, 0.0], [6.0738636553288, 52.334463052951001, 0.0], [6.0754454880953, 52.333419428695997, 0.0], [6.0744461975992, 52.332725816740002, 0.0], [6.0731035843492, 52.328832639677998, 0.0], [6.0710160713643, 52.322990899594998, 0.0], [6.0704872990027, 52.322745323170999, 0.0], [6.0709884949028, 52.322080054476999, 0.0], [6.0690726432949, 52.321956123992003, 0.0], [6.0675353603438, 52.321658079743003, 0.0], [6.0665130615234, 52.320730479418998, 0.0], [6.0661911754869, 52.319453886063002, 0.0], [6.0663842735812, 52.317862457323997, 0.0], [6.07183448039, 52.317093000096001, 0.0], [6.073379390873, 52.317818854678002, 0.0], [6.0795591585338, 52.317600302815002, 0.0], [6.0799400112592, 52.317228690436998, 0.0], [6.0798729455564, 52.316177159473, 0.0], [6.0808358481154, 52.311977300133996, 0.0], [6.0848591197282, 52.311758719423999, 0.0], [6.0830459045246, 52.308470295897003, 0.0], [6.0832148732152, 52.303134751769001, 0.0], [6.0840704874136, 52.303257229381998, 0.0], [6.0841938480735, 52.301612732392002, 0.0], [6.0864334716462, 52.302005311160002, 0.0], [6.0880722803995, 52.300455900910997, 0.0], [6.0909207444638, 52.300086361474001, 0.0], [6.0989351011813, 52.300292057362, 0.0], [6.0988384578377, 52.301285053249003, 0.0], [6.1014025658369, 52.301490743568003, 0.0], [6.1019496945664, 52.299828714878998, 0.0], [6.1042134370655, 52.297904173231998, 0.0], [6.1051038885489, 52.295139659150003, 0.0], [6.10556518659, 52.292873689525997, 0.0], [6.1105003673583, 52.289404547232998, 0.0], [6.1117448285222, 52.287195222275997, 0.0], [6.1115729995072, 52.279756917492001, 0.0], [6.1131822410971, 52.277376439313997, 0.0], [6.1166797578335, 52.275521004345002, 0.0], [6.240961253643, 52.263687554904998, 0.0], [6.2701410055161, 52.249470765780998, 0.0], [6.2709979712963, 52.225854984811001, 0.0], [6.2938275933266, 52.231885163789002, 0.0], [6.2981177866459, 52.225087702651997, 0.0], [6.3381135463715, 52.227543123182997, 0.0], [6.3499554991722, 52.241704527605002, 0.0], [6.3817101716995, 52.246613394891, 0.0], [6.416554749012, 52.242693242442002, 0.0], [6.427366733551, 52.225315259878997, 0.0], [6.4399811625481, 52.216608105553, 0.0], [6.4546555280685, 52.202218417418003, 0.0], [6.4707541465759, 52.200124086907003, 0.0], [6.4259719848633, 52.147816036320997, 0.0], [6.108226776123, 52.044467094924002, 0.0], [6.0102081298828, 52.006970376875998, 0.0], [5.9446334838867, 51.985884478058999, 0.0], [5.9347200393677, 52.004936205492001, 0.0], [5.8961391448975, 52.011989365279, 0.0], [5.8515930175781, 52.021233396705, 0.0], [5.9291839599609, 52.467305322032999, 0.0]].map(function (coords) {
          return { lat: coords[1], lng: coords[0] };
        }),
        charlie: [[6.4259719848633, 52.147816036320997, 0.0], [6.4707541465759, 52.200124086907003, 0.0], [6.4728516340256, 52.186677910138002, 0.0], [6.494175195694, 52.177438500146003, 0.0], [6.5142971277237, 52.181356191756997, 0.0], [6.5266942977905, 52.179905600586999, 0.0], [6.5549218654633, 52.177004276306, 0.0], [6.5891575813293, 52.18262912054, 0.0], [6.606211066246, 52.172770371715004, 0.0], [6.6027530282736, 52.169938908227003, 0.0], [6.6029184870422, 52.169059925265003, 0.0], [6.604199744761, 52.167391259585003, 0.0], [6.607191413641, 52.164580225095001, 0.0], [6.6092875599861, 52.165234209025002, 0.0], [6.6120207309723, 52.163014737730002, 0.0], [6.6145734395832, 52.164231789638002, 0.0], [6.6186281852424, 52.166001599611, 0.0], [6.6215671319515, 52.168245136042003, 0.0], [6.6232511820272, 52.168129746204997, 0.0], [6.6251927241683, 52.168804010362997, 0.0], [6.6264357604086, 52.171527284790997, 0.0], [6.6252755373716, 52.172197513542002, 0.0], [6.6255269944668, 52.172457007281999, 0.0], [6.6292914748192, 52.172081131547003, 0.0], [6.630184315145, 52.173470910071998, 0.0], [6.635239943862, 52.171991891437003, 0.0], [6.6402013599873, 52.167875548201003, 0.0], [6.6448885202408, 52.174145530213998, 0.0], [6.6655710339546, 52.167484827434997, 0.0], [6.6653122007847, 52.166852263806, 0.0], [6.6713190078735, 52.165745872770003, 0.0], [6.6733065247536, 52.163602110436997, 0.0], [6.6725045442581, 52.161431918898998, 0.0], [6.6736337542534, 52.161446727236999, 0.0], [6.6739046573639, 52.158670900589001, 0.0], [6.6705840826035, 52.156383634139999, 0.0], [6.6736015677452, 52.154976660062999, 0.0], [6.6728787124157, 52.152851304370998, 0.0], [6.6736330837011, 52.152051904107999, 0.0], [6.6728086397052, 52.150519920154998, 0.0], [6.6713833808899, 52.150304528900001, 0.0], [6.6736096143723, 52.148352588149002, 0.0], [6.6743338108063, 52.143319280367002, 0.0], [6.6720780730247, 52.138866517876998, 0.0], [6.6665607690811, 52.134834778871998, 0.0], [6.6627359390259, 52.129826287838, 0.0], [6.6767022013664, 52.12607037339, 0.0], [6.697878241539, 52.123368092698001, 0.0], [6.7161977291107, 52.118173852363, 0.0], [6.7600464820862, 52.119379418012997, 0.0], [6.7550012469292, 52.095457999028, 0.0], [6.7498775571585, 52.095592707215999, 0.0], [6.7437238991261, 52.093618182257003, 0.0], [6.7452819272876, 52.089994147493002, 0.0], [6.750959828496, 52.087846531620997, 0.0], [6.7496126890182, 52.084605856579003, 0.0], [6.7347827553749, 52.074384136643999, 0.0], [6.7132915556431, 52.073282042377997, 0.0], [6.6948902606964, 52.069858534929999, 0.0], [6.6962823271751, 52.068155339059999, 0.0], [6.6899402439594, 52.056749837411999, 0.0], [6.6871125251055, 52.056535023583997, 0.0], [6.6865569725633, 52.05262758181, 0.0], [6.6887480020523, 52.052520165113997, 0.0], [6.6884422302246, 52.039821321105002, 0.0], [6.7136549949646, 52.040098497293002, 0.0], [6.7536413669586, 52.028198172690999, 0.0], [6.7641073465347, 52.022669351597003, 0.0], [6.7663335800171, 52.019041413452001, 0.0], [6.7728513479233, 52.018371252553997, 0.0], [6.8116414546967, 51.998258454123999, 0.0], [6.8078541755676, 51.994909295729997, 0.0], [6.8265545368195, 51.993303988980998, 0.0], [6.8301567435265, 51.986348646464997, 0.0], [6.8298979103565, 51.976209353649999, 0.0], [6.8330723047256, 51.972413239813001, 0.0], [6.8286037445068, 51.963995377182997, 0.0], [6.8138301372528, 51.963922660057001, 0.0], [6.8121939897537, 51.962035278827003, 0.0], [6.7992281913757, 51.958666882639001, 0.0], [6.7972433567047, 51.943094265039001, 0.0], [6.7943438887596, 51.934940454991001, 0.0], [6.7856079339981, 51.931442676110002, 0.0], [6.7880487442017, 51.929315760953003, 0.0], [6.7701423168182, 51.915903619879998, 0.0], [6.764163672924, 51.915461884030002, 0.0], [6.754065155983, 51.913114158779003, 0.0], [6.7537808418274, 51.910324524385999, 0.0], [6.751007437706, 51.907375861222, 0.0], [6.7369043827057, 51.904638825542001, 0.0], [6.7323875427246, 51.898740559021, 0.0], [6.7223024368286, 51.896436648658998, 0.0], [6.702926158905, 51.906300262499002, 0.0], [6.7040526866913, 51.909536909403997, 0.0], [6.6998094320297, 51.909248996278002, 0.0], [6.6955661773682, 51.915738176250002, 0.0], [6.6839361190796, 51.917882278444999, 0.0], [6.6372656822205, 51.904340951861997, 0.0], [6.6338431835175, 51.900852373070997, 0.0], [6.6264671087265, 51.901544152638998, 0.0], [6.6221809387207, 51.900964912098999, 0.0], [6.5843081474304, 51.893669151874001, 0.0], [6.5684616565704, 51.888537576457999, 0.0], [6.5605115890503, 51.882345799093997, 0.0], [6.5549111366272, 51.882253081507997, 0.0], [6.5517139434814, 51.886398695251998, 0.0], [6.5286898612976, 51.876451229354998, 0.0], [6.5248167514801, 51.873861348186999, 0.0], [6.515793800354, 51.873179078452999, 0.0], [6.5020394325256, 51.867786796190003, 0.0], [6.500655412674, 51.862652265693001, 0.0], [6.4822822809219, 51.857116254037997, 0.0], [6.4746406674385, 51.856150446733999, 0.0], [6.4735221862793, 51.853912278430997, 0.0], [6.4615702629089, 51.855940053714001, 0.0], [6.4513349533081, 51.865388546501997, 0.0], [6.4325165748596, 51.859889314504997, 0.0], [6.4122927188873, 51.871344185193003, 0.0], [6.4021807909012, 51.869227672008002, 0.0], [6.3913822174072, 51.873470534752002, 0.0], [6.3875412940979, 51.861744552245, 0.0], [6.4005553722382, 51.856092464504002, 0.0], [6.4091062545776, 51.854044815553998, 0.0], [6.4014887809753, 51.843798544728998, 0.0], [6.4081513881683, 51.836128884498997, 0.0], [6.4027279615402, 51.836642666612001, 0.0], [6.4079475402832, 51.827821374271998, 0.0], [6.4011253416538, 51.826898867649, 0.0], [6.392243206501, 51.832023389112003, 0.0], [6.380678191781, 51.835619654345997, 0.0], [6.3684265315533, 51.833699941627003, 0.0], [6.3617759943008, 51.835376431728001, 0.0], [6.3596329092979, 51.846471349612003, 0.0], [6.346846818924, 51.850777661681001, 0.0], [6.3253945112228, 51.851967251250002, 0.0], [6.3063454627991, 51.849127426872002, 0.0], [6.2986314296722, 51.868257156128998, 0.0], [6.2837076187134, 51.872119221443, 0.0], [6.2782479822636, 51.874668632136, 0.0], [6.2700417637825, 51.874674427968998, 0.0], [6.2615257501602, 51.868114723708999, 0.0], [6.2458670139313, 51.870045803937998, 0.0], [6.2412133812904, 51.868838474470003, 0.0], [6.2324398756027, 51.870174981303002, 0.0], [6.2145495414734, 51.867760296892001, 0.0], [6.1983825266361, 51.873264362736002, 0.0], [6.1835888028145, 51.882370634129003, 0.0], [6.1818104982376, 51.885746415561002, 0.0], [6.1913618445396, 51.887426761538997, 0.0], [6.1887560784817, 51.888902599809001, 0.0], [6.1913001537323, 51.891861579900002, 0.0], [6.1796513199806, 51.895448512972997, 0.0], [6.1693757772446, 51.901577251873, 0.0], [6.1654517054558, 51.898278793350997, 0.0], [6.1584377288818, 51.905783965962002, 0.0], [6.1249852180481, 51.898568431870999, 0.0], [6.1179953813553, 51.901795706203998, 0.0], [6.1147820949554, 51.898244036603003, 0.0], [6.1124271154404, 51.899141083106997, 0.0], [6.1098763346672, 51.895140647162997, 0.0], [6.1028623580933, 51.893046772661997, 0.0], [6.1055780947208, 51.891602521732999, 0.0], [6.1161902546883, 51.892700818786999, 0.0], [6.1223083734512, 51.890447915255002, 0.0], [6.1376345157623, 51.885729860116001, 0.0], [6.1435809731483, 51.876005793662998, 0.0], [6.1447209119797, 51.869459532770001, 0.0], [6.1672568321228, 51.861665043625003, 0.0], [6.1639335751534, 51.859755138094002, 0.0], [6.1637002229691, 51.852755875469001, 0.0], [6.1680400371552, 51.84129958546, 0.0], [6.1011403799057, 51.850628546564003, 0.0], [6.0631656646729, 51.865574051041001, 0.0], [6.0562133789062, 51.885921902905999, 0.0], [6.0497760772705, 51.913938110162, 0.0], [6.0416221618652, 51.942148492442001, 0.0], [6.0102081298828, 52.006970376875998, 0.0], [6.108226776123, 52.044467094924002, 0.0], [6.4259719848633, 52.147816036320997, 0.0]].map(function (coords) {
          return { lat: coords[1], lng: coords[0] };
        }),
        delta: [[5.8505630493164, 51.890265824069999, 0.0], [5.8531379699707, 51.966057850188001, 0.0], [5.8706903457642, 51.97297173071, 0.0], [5.9253215789795, 51.984642267058, 0.0], [5.9446334838867, 51.985884478058999, 0.0], [6.0102081298828, 52.006970376875998, 0.0], [6.0416221618652, 51.942148492442001, 0.0], [6.0497760772705, 51.913938110162, 0.0], [6.0562133789062, 51.885921902905999, 0.0], [6.0631656646729, 51.865574051041001, 0.0], [6.0598263144493, 51.857586725558001, 0.0], [6.0506504774094, 51.857020171221002, 0.0], [6.0553014278412, 51.852494106777002, 0.0], [6.0323309898376, 51.842380054366998, 0.0], [6.0294637084007, 51.845551710540001, 0.0], [6.0176700353622, 51.841511704101002, 0.0], [6.0046747326851, 51.833440548310001, 0.0], [5.9865295886993, 51.830672488243998, 0.0], [5.962700843811, 51.836785198675997, 0.0], [5.9450840950012, 51.823763198499996, 0.0], [5.9577333927155, 51.817038553528, 0.0], [5.9470769762993, 51.816365370588002, 0.0], [5.947750210762, 51.811022660694, 0.0], [5.96405133605, 51.806971263846997, 0.0], [5.9789791703224, 51.797824016691003, 0.0], [5.9717248007655, 51.789697332896999, 0.0], [5.9747701138258, 51.785179847796996, 0.0], [5.9897871315479, 51.783153033607, 0.0], [5.9818890318274, 51.773669436454, 0.0], [5.992187038064, 51.770132958044996, 0.0], [5.9908129088581, 51.76613370239, 0.0], [5.9743325784802, 51.759584117167996, 0.0], [5.955792311579, 51.752289703965999, 0.0], [5.9520149230957, 51.744356390187001, 0.0], [5.943421125412, 51.740974983081003, 0.0], [5.9331107139587, 51.741845271176999, 0.0], [5.9324133396149, 51.748773760806003, 0.0], [5.9142065048218, 51.752088165766999, 0.0], [5.9024906158447, 51.76895531521, 0.0], [5.8924269676208, 51.779032753221998, 0.0], [5.8682870864868, 51.77572696427, 0.0], [5.8661198616028, 51.757441179941999, 0.0], [5.8451235294342, 51.759240872200003, 0.0], [5.8200073242188, 51.757640411398, 0.0], [5.804386138916, 51.813443706413999, 0.0], [5.8367443084717, 51.849644374405003, 0.0], [5.8505630493164, 51.890265824069999, 0.0]].map(function (coords) {
          return { lat: coords[1], lng: coords[0] };
        }),
        echo: [[5.8505630493164, 51.890265824069999, 0.0], [5.8367443084717, 51.849644374405003, 0.0], [5.804386138916, 51.813443706413999, 0.0], [5.8200073242188, 51.757640411398, 0.0], [5.7766628265381, 51.752008463491002, 0.0], [5.753960609436, 51.755090182377998, 0.0], [5.7437038421631, 51.760137371097002, 0.0], [5.7320308685303, 51.772487321682, 0.0], [5.7179546356201, 51.775687134011001, 0.0], [5.7076549530029, 51.775587558208997, 0.0], [5.7013034820557, 51.778355683640001, 0.0], [5.6973230838776, 51.784515314986997, 0.0], [5.6893944740295, 51.790461747329999, 0.0], [5.6708228588104, 51.792585283191997, 0.0], [5.6632375717163, 51.794602549651003, 0.0], [5.6563550233841, 51.798530651699998, 0.0], [5.6513607501984, 51.803732206155999, 0.0], [5.6459373235703, 51.814027391129002, 0.0], [5.6401705741882, 51.818696596697002, 0.0], [5.6314118206501, 51.819843926852002, 0.0], [5.6178465485573, 51.819930141232, 0.0], [5.6030756235123, 51.826468689636997, 0.0], [5.5939735472202, 51.829207170815003, 0.0], [5.5838415026665, 51.829611629710001, 0.0], [5.5730228126049, 51.827576037428003, 0.0], [5.5618607997894, 51.82851096257, 0.0], [5.5524368584156, 51.825613294564, 0.0], [5.5478194355965, 51.819320005145002, 0.0], [5.5383954942226, 51.816103390271998, 0.0], [5.5303448438644, 51.818192558028002, 0.0], [5.5180884897709, 51.818371625043, 0.0], [5.5099520087242, 51.823431632037, 0.0], [5.4971122741699, 51.830791833265003, 0.0], [5.4853749275208, 51.829359672136, 0.0], [5.4736697673798, 51.813894736176003, 0.0], [5.4633378982544, 51.810525169439003, 0.0], [5.4494762420654, 51.809994506046003, 0.0], [5.4358050227165, 51.809553387346, 0.0], [5.4259103536606, 51.81208395702, 0.0], [5.4191055893898, 51.817161250813001, 0.0], [5.4143607616425, 51.821813552683999, 0.0], [5.4060244560242, 51.822808280479997, 0.0], [5.3997105360031, 51.819910245620001, 0.0], [5.3944265842438, 51.813616159502999, 0.0], [5.384202003479, 51.806120473996003, 0.0], [5.3621864318848, 51.778249475724998, 0.0], [5.3596758842468, 51.759579551652998, 0.0], [5.346919298172, 51.753854863420997, 0.0], [5.3269529342651, 51.747704331759998, 0.0], [5.2962899208069, 51.736995360582, 0.0], [5.2826750278473, 51.740569728704997, 0.0], [5.2711200714111, 51.739892082120001, 0.0], [5.2485251426697, 51.733540312269, 0.0], [5.2416238188744, 51.735536963751997, 0.0], [5.2360957860947, 51.739659553989, 0.0], [5.2209198474884, 51.743864806447, 0.0], [5.2101373672485, 51.742496315433002, 0.0], [5.1965492963791, 51.740323916903002, 0.0], [5.1685416698456, 51.743041059541, 0.0], [5.1266026496887, 51.737633186770999, 0.0], [5.1253232359886, 51.744067419312003, 0.0], [5.1369573175907, 51.749622311491002, 0.0], [5.1430982351303, 51.754645205787, 0.0], [5.137737840414, 51.757143991386997, 0.0], [5.135124027729, 51.761448883713001, 0.0], [5.1397669315338, 51.769632525837999, 0.0], [5.1381093263626, 51.772454127419003, 0.0], [5.11908441782, 51.777847874787, 0.0], [5.1061387360096, 51.784580026477002, 0.0], [5.0988075882196, 51.787574075846997, 0.0], [5.0923347473145, 51.787382442729999, 0.0], [5.0835907459259, 51.781143552, 0.0], [5.0750184059143, 51.779046028994003, 0.0], [5.0691443681717, 51.779271716530999, 0.0], [5.0644719600677, 51.781515254765999, 0.0], [5.0587320327759, 51.787594815313, 0.0], [5.0451493263245, 51.799141069271002, 0.0], [5.0190353393555, 51.806545041699003, 0.0], [5.0138318538666, 51.808069140469001, 0.0], [5.011031627655, 51.811503563689001, 0.0], [5.0085210800171, 51.818159397392002, 0.0], [5.00075340271, 51.821070808274001, 0.0], [5.0264167785645, 51.818829237514997, 0.0], [5.0312232971191, 51.840855458817998, 0.0], [5.0069546699524, 51.843071076866998, 0.0], [4.9988222122192, 51.844809357548002, 0.0], [5.0007694959641, 51.848047534142999, 0.0], [4.9985110759735, 51.851391513705998, 0.0], [4.9972558021545, 51.856276350747997, 0.0], [4.993662647903, 51.860950520891997, 0.0], [4.994355160743, 51.861723782184001, 0.0], [4.9959059804678, 51.861807962339, 0.0], [5.0017659366131, 51.858858237198, 0.0], [5.0072202086449, 51.857888429397001, 0.0], [5.0172704458237, 51.859182399102998, 0.0], [5.0268486142159, 51.858462013134996, 0.0], [5.038400888443, 51.859172874098, 0.0], [5.0420781970024, 51.860374044159002, 0.0], [5.0471817702055, 51.85881904979, 0.0], [5.0541736185551, 51.857635076995997, 0.0], [5.0587622076273, 51.858279947680998, 0.0], [5.0628358125687, 51.859825953471997, 0.0], [5.0631560012698, 51.861476857135997, 0.0], [5.0599571317434, 51.862809674676001, 0.0], [5.0534735620022, 51.865316187102003, 0.0], [5.0515390187502, 51.867239572168998, 0.0], [5.0517502427101, 51.869692841456001, 0.0], [5.0526712462306, 51.871701093736, 0.0], [5.0554805248976, 51.873444297551998, 0.0], [5.0641889870167, 51.874704959573002, 0.0], [5.0711345672607, 51.874152800064003, 0.0], [5.0741010904312, 51.874368489795998, 0.0], [5.0792133808136, 51.875432019625002, 0.0], [5.0823944807053, 51.876972416629997, 0.0], [5.0842881202698, 51.879095602431001, 0.0], [5.0868737697601, 51.882043638399999, 0.0], [5.0872278213501, 51.885362327659998, 0.0], [5.0869810581207, 51.887740474346003, 0.0], [5.0925707817078, 51.889323904252997, 0.0], [5.0952664017677, 51.888713259835001, 0.0], [5.0974470376968, 51.888076119794, 0.0], [5.1051208376884, 51.889160638903, 0.0], [5.1125371456146, 51.887914298441999, 0.0], [5.1174563169479, 51.892109463234, 0.0], [5.118511095643, 51.896457389759, 0.0], [5.1166476309299, 51.896991637867998, 0.0], [5.1170157641172, 51.898479213061002, 0.0], [5.1189288496971, 51.898483816239001, 0.0], [5.1233196258545, 51.903586329698001, 0.0], [5.1233196258545, 51.903586329698001, 0.0], [5.1233196258545, 51.903586329698001, 0.0], [5.1233196258545, 51.903586329698001, 0.0], [5.1233196258545, 51.903586329698001, 0.0], [5.1233196258545, 51.903586329698001, 0.0], [5.4094791412354, 51.886703309936998, 0.0], [5.469388961792, 51.896516095811002, 0.0], [5.5153298377991, 51.906287024199997, 0.0], [5.5890798568726, 51.911820292963, 0.0], [5.7424807548523, 51.900832513212997, 0.0], [5.8505630493164, 51.890265824069999, 0.0]].map(function (coords) {
          return { lat: coords[1], lng: coords[0] };
        }),
        foxtrot: [[5.8515930175781, 52.021233396705, 0.0], [5.8961391448975, 52.011989365279, 0.0], [5.9347200393677, 52.004936205492001, 0.0], [5.9446334838867, 51.985884478058999, 0.0], [5.9253215789795, 51.984642267058, 0.0], [5.8706903457642, 51.97297173071, 0.0], [5.8531379699707, 51.966057850188001, 0.0], [5.8505630493164, 51.890265824069999, 0.0], [5.7424807548523, 51.900832513212997, 0.0], [5.5890798568726, 51.911820292963, 0.0], [5.5153298377991, 51.906287024199997, 0.0], [5.469388961792, 51.896516095811002, 0.0], [5.4094791412354, 51.886703309936998, 0.0], [5.1233196258545, 51.903586329698001, 0.0], [5.132063627243, 51.914828225390004, 0.0], [5.1360011100769, 51.914315335871002, 0.0], [5.13547539711, 51.918196605809001, 0.0], [5.1459360122681, 51.927582399403001, 0.0], [5.1480670273304, 51.929346772298999, 0.0], [5.1487999409437, 51.930460478886999, 0.0], [5.1483097672462, 51.930952303757998, 0.0], [5.1476620137691, 51.932028552410003, 0.0], [5.1484324783087, 51.933122346864998, 0.0], [5.1494389772415, 51.933726599501, 0.0], [5.1506754755974, 51.933471090312999, 0.0], [5.1511609554291, 51.933652179498999, 0.0], [5.1536124944687, 51.937077025481997, 0.0], [5.1556134223938, 51.939152311944, 0.0], [5.1752471923828, 51.962144359065, 0.0], [5.180139541626, 51.967432779465, 0.0], [5.1829826831818, 51.969402556559999, 0.0], [5.1930356025696, 51.967564981980999, 0.0], [5.1993978023529, 51.965991746756004, 0.0], [5.2073049545288, 51.968040907807001, 0.0], [5.2127766609192, 51.970261828170003, 0.0], [5.2215850353241, 51.974465411800999, 0.0], [5.2263110876083, 51.979488044897003, 0.0], [5.2371311187744, 51.983241434598, 0.0], [5.2437521517277, 51.984296192831003, 0.0], [5.2571967244148, 51.981016201460001, 0.0], [5.2676063776016, 51.974640552560999, 0.0], [5.2779972553253, 51.967069220536999, 0.0], [5.2964615821838, 51.962104693554998, 0.0], [5.3055220842361, 51.959661891562, 0.0], [5.3163702785969, 51.954819692710998, 0.0], [5.3309950232506, 51.956113145711001, 0.0], [5.3399884700775, 51.960815545357001, 0.0], [5.3497356176376, 51.968949779890998, 0.0], [5.3610277175903, 51.970949233595, 0.0], [5.3766167163849, 51.968867155917998, 0.0], [5.3941959142685, 51.971633323718002, 0.0], [5.4189848899841, 51.977148625326002, 0.0], [5.4330289363861, 51.984794241529997, 0.0], [5.48415184021, 51.98250135448, 0.0], [5.4917907714844, 52.000524113476999, 0.0], [5.6658554077148, 52.015317436634, 0.0], [5.8515930175781, 52.021233396705, 0.0]].map(function (coords) {
          return { lat: coords[1], lng: coords[0] };
        })
      };
    }
  },
  mounted: function mounted() {
    this.$store.dispatch('RETRIEVE_FOX_LOCATIONS');
    this.$store.dispatch('RETRIEVE_POIS');
    this.$store.dispatch('RETRIEVE_CARS');
    this.$store.dispatch('RETRIEVE_GROUPS');
  },

  components: {
    FoxPath: __WEBPACK_IMPORTED_MODULE_0__components_maps_FoxPath__["a" /* default */],
    FoxPosition: __WEBPACK_IMPORTED_MODULE_1__components_maps_FoxPosition__["a" /* default */],
    FoxCircle: __WEBPACK_IMPORTED_MODULE_2__components_maps_FoxCircle__["a" /* default */],
    AddFoxModal: __WEBPACK_IMPORTED_MODULE_4__components_AddFoxModal__["a" /* default */],
    AddPoiModal: __WEBPACK_IMPORTED_MODULE_5__components_AddPoiModal__["a" /* default */],
    CountdownBar: __WEBPACK_IMPORTED_MODULE_3__components_maps_CountdownBar__["a" /* default */]
  },
  methods: {
    update: function update(type, e) {
      if (type == 'zoom') {
        this.$store.commit('SET_SETTING_MAP_ZOOM', e);
      }

      if (type == 'center') {
        // console.log(e.lat())
        // this.$store.commit('SET_SETTING_MAP_CENTER', {lat: parseFloat(e.lat()), lng: parseFloat(e.lng())});
      }
    },
    closeAddFox: function closeAddFox() {
      this.modals.addFox = false;
    },
    closeAddPoi: function closeAddPoi() {
      this.modals.addPoi = false;
    },
    addPoint: function addPoint(e) {
      this.click_location = { lat: e.latLng.lat(), lng: e.latLng.lng() };
      if (this.action == 'add_fox') {
        this.modals.addFox = true;
      } else if (this.action == 'add_poi') {
        this.modals.addPoi = true;
      }

      this.action = null;
    },
    openGroupInfo: function openGroupInfo(group) {
      this.info.open = true;
      this.info.content = group.naam;
      this.info.position = { lat: group.lat, lng: group.lng };
    },
    openPoiInfo: function openPoiInfo(poi) {
      this.info.open = true;
      this.info.content = poi.description;
      this.info.position = { lat: poi.lat, lng: poi.lng };
    },
    openCarInfo: function openCarInfo(car) {
      this.info.open = true;
      var t = new Date(car.time);
      this.info.content = car.name + ' - ' + t.toLocaleString();
      this.info.position = { lat: car.lat, lng: car.lng };
    }
  }
});

/***/ }),

/***/ "gSsR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'car',
    data: function data() {
        return {
            position: {
                lat: 0,
                lng: 0
            },
            timestamp: null
        };
    },

    computed: {
        user: function user() {
            return this.$store.getters.user;
        }
    },
    mounted: function mounted() {
        var _this = this;

        this.$store.dispatch('init');

        if (navigator.geolocation) {
            navigator.geolocation.watchPosition(function (pos) {
                _this.position.lat = pos.coords.latitude;
                _this.position.lng = pos.coords.longitude;
                _this.timestamp = pos.timestamp;

                if (_this.user) {
                    _this.$store.dispatch('ADD_CAR_LOCATION', {
                        email: _this.user.email,
                        name: _this.user.name,
                        lat: _this.position.lat,
                        lng: _this.position.lng,
                        time: _this.timestamp
                    });
                }
            });
        }
    }
});

/***/ }),

/***/ "iL7n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('gmap-polyline',{attrs:{"path":_vm.path}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "iXMs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CountdownBar_vue__ = __webpack_require__("B2NC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c3b190fa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CountdownBar_vue__ = __webpack_require__("dm2N");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CountdownBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c3b190fa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CountdownBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jcYF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddFoxModal_vue__ = __webpack_require__("LBOl");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d3821e9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddFoxModal_vue__ = __webpack_require__("V6q9");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddFoxModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d3821e9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddFoxModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kbv/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'fox-position',
  props: ['fox', 'onClick'],
  computed: {
    image: function image() {
      return 'static/' + this.fox + '.png';
    },
    position: function position() {
      var pos = this.$store.getters[this.fox][0];
      if (pos == undefined) return false;

      return { lat: parseFloat(pos.lat), lng: parseFloat(pos.lng) };
    }
  },
  methods: {}
});

/***/ }),

/***/ "lTUX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Car_vue__ = __webpack_require__("gSsR");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f95cde40_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Car_vue__ = __webpack_require__("cdT5");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Car_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f95cde40_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Car_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lk2w":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nKb+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'hello',
  data: function data() {
    return {
      message: null,
      creds: {
        email: '',
        password: ''
      }
    };
  },

  methods: {
    login: function login() {
      var _this = this;

      this.$store.dispatch("login", this.creds).then(function () {
        _this.$router.push("/");
      }).catch(function (error) {
        _this.message = error.message;
      });
    }
  }
});

/***/ }),

/***/ "niH5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Settings_vue__ = __webpack_require__("JZSy");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1303a17c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Settings_vue__ = __webpack_require__("KOE2");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Settings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1303a17c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Settings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ovGn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'fox-circle',
    props: ['fox'],
    data: function data() {
        return {
            radius: 0,
            options: {
                clickable: false
            }
        };
    },
    mounted: function mounted() {
        var _this = this;

        //this.setRadius();
        setInterval(function () {
            _this.setRadius();
        }, 30000);
    },

    methods: {
        setRadius: function setRadius() {
            if (this.$store.getters[this.fox]) {
                var time = this.$store.getters[this.fox][0].time;
                var now = Date.now();
                var speed = 5000;
                var diff = now - time;

                this.radius = diff / 1000 / 60 / 60 * speed;

                if (this.radius >= 10000) this.radius = 10000;
            }
        }
    },
    computed: {
        position: function position() {
            var pos = this.$store.getters[this.fox][0];
            if (pos == undefined) return false;

            this.setRadius();
            return { lat: parseFloat(pos.lat), lng: parseFloat(pos.lng) };
        }
    }
});

/***/ }),

/***/ "preG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js__ = __webpack_require__("osty");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js__) if(["default","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_ff36f0b0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_autocomplete_vue__ = __webpack_require__("H7H4");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_ff36f0b0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_autocomplete_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "qhk6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FoxLocationHistoryTable_vue__ = __webpack_require__("b9Wf");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c5f6d130_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FoxLocationHistoryTable_vue__ = __webpack_require__("bN8B");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FoxLocationHistoryTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c5f6d130_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FoxLocationHistoryTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-SG": "oYA3",
	"./en-SG.js": "oYA3",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./ga": "U5Iz",
	"./ga.js": "U5Iz",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it-ch": "/E8D",
	"./it-ch.js": "/E8D",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ku": "kI9l",
	"./ku.js": "kI9l",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "vaHE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddPoiModal_vue__ = __webpack_require__("d7Nw");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a3cf197_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddPoiModal_vue__ = __webpack_require__("Okwi");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddPoiModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a3cf197_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddPoiModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vaPR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-street-view-pano-container"},[_c('div',{ref:"vue-street-view-pano",staticClass:"vue-street-view-pano"}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wauf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FoxLocationHistoryTable__ = __webpack_require__("qhk6");
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'fox-overview',
  mounted: function mounted() {
    this.$store.dispatch('RETRIEVE_FOX_LOCATIONS');
  },

  components: {
    FoxLocationHistoryTable: __WEBPACK_IMPORTED_MODULE_0__components_FoxLocationHistoryTable__["a" /* default */]
  }
});

/***/ }),

/***/ "xDxW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('gmap-map',{staticStyle:{"width":"100vw","height":"calc(100vh - (65px + 57px))"},attrs:{"center":_vm.settings.maps.center,"zoom":_vm.settings.maps.zoom,"map-type-id":"roadmap"},on:{"click":_vm.addPoint,"zoom_changed":function($event){return _vm.update('zoom', $event)},"center_changed":function($event){return _vm.update('center', $event)}}},[_c('gmap-info-window',{attrs:{"infoOptions":_vm.info.options,"opened":_vm.info.open,"position":_vm.info.position},on:{"closeclick":function($event){_vm.info.open = false}}},[_vm._v(_vm._s(_vm.info.content))]),_vm._v(" "),(_vm.settings.foxPath)?_c('fox-path',{attrs:{"fox":"alpha"}}):_vm._e(),_vm._v(" "),(_vm.settings.fox)?_c('fox-position',{attrs:{"fox":"alpha"}}):_vm._e(),_vm._v(" "),(_vm.settings.foxCircle)?_c('fox-circle',{attrs:{"fox":"alpha"}}):_vm._e(),_vm._v(" "),(_vm.settings.foxPath)?_c('fox-path',{attrs:{"fox":"bravo"}}):_vm._e(),_vm._v(" "),(_vm.settings.fox)?_c('fox-position',{attrs:{"fox":"bravo"}}):_vm._e(),_vm._v(" "),(_vm.settings.foxCircle)?_c('fox-circle',{attrs:{"fox":"bravo"}}):_vm._e(),_vm._v(" "),(_vm.settings.foxPath)?_c('fox-path',{attrs:{"fox":"charlie"}}):_vm._e(),_vm._v(" "),(_vm.settings.fox)?_c('fox-position',{attrs:{"fox":"charlie"}}):_vm._e(),_vm._v(" "),(_vm.settings.foxCircle)?_c('fox-circle',{attrs:{"fox":"charlie"}}):_vm._e(),_vm._v(" "),(_vm.settings.foxPath)?_c('fox-path',{attrs:{"fox":"delta"}}):_vm._e(),_vm._v(" "),(_vm.settings.fox)?_c('fox-position',{attrs:{"fox":"delta"}}):_vm._e(),_vm._v(" "),(_vm.settings.foxCircle)?_c('fox-circle',{attrs:{"fox":"delta"}}):_vm._e(),_vm._v(" "),(_vm.settings.foxPath)?_c('fox-path',{attrs:{"fox":"echo"}}):_vm._e(),_vm._v(" "),(_vm.settings.fox)?_c('fox-position',{attrs:{"fox":"echo"}}):_vm._e(),_vm._v(" "),(_vm.settings.foxCircle)?_c('fox-circle',{attrs:{"fox":"echo"}}):_vm._e(),_vm._v(" "),(_vm.settings.foxPath)?_c('fox-path',{attrs:{"fox":"foxtrot"}}):_vm._e(),_vm._v(" "),(_vm.settings.fox)?_c('fox-position',{attrs:{"fox":"foxtrot"}}):_vm._e(),_vm._v(" "),(_vm.settings.foxCircle)?_c('fox-circle',{attrs:{"fox":"foxtrot"}}):_vm._e(),_vm._v(" "),(_vm.settings.zones)?_c('gmap-polygon',{attrs:{"options":_vm.polyOptions,"path":_vm.zones.alpha}}):_vm._e(),_vm._v(" "),(_vm.settings.zones)?_c('gmap-polygon',{attrs:{"options":_vm.polyOptions,"path":_vm.zones.bravo}}):_vm._e(),_vm._v(" "),(_vm.settings.zones)?_c('gmap-polygon',{attrs:{"options":_vm.polyOptions,"path":_vm.zones.charlie}}):_vm._e(),_vm._v(" "),(_vm.settings.zones)?_c('gmap-polygon',{attrs:{"options":_vm.polyOptions,"path":_vm.zones.delta}}):_vm._e(),_vm._v(" "),(_vm.settings.zones)?_c('gmap-polygon',{attrs:{"options":_vm.polyOptions,"path":_vm.zones.echo}}):_vm._e(),_vm._v(" "),(_vm.settings.zones)?_c('gmap-polygon',{attrs:{"options":_vm.polyOptions,"path":_vm.zones.foxtrot}}):_vm._e(),_vm._v(" "),(_vm.groups)?_c('div',_vm._l((_vm.groups),function(g,index){return _c('div',{key:index},[_c('gmap-circle',{key:index,attrs:{"center":{lat: parseFloat(g.lat), lng: parseFloat(g.lng)},"radius":500}}),_vm._v(" "),_c('gmap-marker',{key:g.naam,attrs:{"position":{lat: g.lat, lng: g.lng},"icon":_vm.groupIcon},on:{"click":function($event){return _vm.openGroupInfo(g)}}})],1)}),0):_vm._e(),_vm._v(" "),(_vm.pois)?_c('div',_vm._l((_vm.pois),function(p){return _c('gmap-marker',{key:p.id,attrs:{"position":{lat: p.lat, lng: p.lng},"icon":"static/poi.png"},on:{"click":function($event){return _vm.openPoiInfo(p)}}})}),1):_vm._e()],1),_vm._v(" "),_c('add-fox-modal',{attrs:{"open":_vm.modals.addFox,"position":_vm.click_location,"close":_vm.closeAddFox}}),_vm._v(" "),_c('add-poi-modal',{attrs:{"open":_vm.modals.addPoi,"position":_vm.click_location,"close":_vm.closeAddPoi}}),_vm._v(" "),_c('countdown-bar'),_vm._v(" "),(_vm.user.role == 99)?_c('v-speed-dial',{staticStyle:{"position":"absolute","bottom":"100px"},attrs:{"bottom":true,"left":true},model:{value:(_vm.actions_dial),callback:function ($$v) {_vm.actions_dial=$$v},expression:"actions_dial"}},[_c('v-btn',{staticClass:"blue darken-2 white--text",staticStyle:{"position":"relative"},attrs:{"slot":"activator","dark":"","fab":"","hover":""},slot:"activator",model:{value:(_vm.actions_dial),callback:function ($$v) {_vm.actions_dial=$$v},expression:"actions_dial"}},[_c('v-icon',[_vm._v("add")])],1),_vm._v(" "),_c('v-btn',{staticClass:"green white--text",staticStyle:{"position":"relative"},attrs:{"fab":"","dark":"","small":""},on:{"click":function($event){_vm.action = 'add_fox'}}},[_c('v-icon',[_vm._v("pets")])],1),_vm._v(" "),_c('v-btn',{staticClass:"green white--text",staticStyle:{"position":"relative"},attrs:{"fab":"","dark":"","small":""},on:{"click":function($event){_vm.action = 'add_poi'}}},[_c('v-icon',[_vm._v("local_activity")])],1)],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ }),

/***/ "xJsL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__("nKb+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f000ab8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__("0eij");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f000ab8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xSZb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_UserService__ = __webpack_require__("+q4l");


var _actions;



var users = {
    state: {
        users: []
    },
    mutations: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, 'SET_USERS', function SET_USERS(state, users) {
        state.users = users;
    }),
    actions: (_actions = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, 'RETRIEVE_USERS', function RETRIEVE_USERS(_ref) {
        var commit = _ref.commit;

        __WEBPACK_IMPORTED_MODULE_1__services_UserService__["a" /* default */].get(function (users) {
            commit('SET_USERS', users);
        });
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, 'CHANGE_USER_ROLE', function CHANGE_USER_ROLE(_ref2, user) {
        var commit = _ref2.commit;

        console.log(user);
        __WEBPACK_IMPORTED_MODULE_1__services_UserService__["a" /* default */].changeRole(user);
    }), _actions),
    getters: {
        users: function users(state) {
            return state.users;
        }
    }
};

/* harmony default export */ __webpack_exports__["a"] = (users);

/***/ }),

/***/ "xyay":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__firebase__ = __webpack_require__("J1c9");



var db = __WEBPACK_IMPORTED_MODULE_1__firebase__["a" /* default */].firestore();

/* harmony default export */ __webpack_exports__["a"] = ({
    add: function add(payload) {
        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
            db.collection('pois').add(payload).then(function (ref) {
                resolve(ref.id);
            }).catch(function (err) {
                console.log(err);
            });
        });
    },
    get: function get(cb) {
        db.collection('pois').onSnapshot(function (snap) {
            var pois = [];
            snap.forEach(function (doc) {
                var data = doc.data();
                data.id = doc.id;
                pois.push(data);
            });
            cb(pois);
        });
    },
    remove: function remove(poi) {
        db.collection('pois').doc(poi.id).delete();
    }
});

/***/ }),

/***/ "yV3O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'fox-path',
  props: ['fox'],
  computed: {
    path: function path() {
      return this.$store.getters[this.fox].map(function (el) {
        return { lat: parseFloat(el.lat), lng: parseFloat(el.lng) };
      });
    }
  }
});

/***/ }),

/***/ "zdjR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":""},model:{value:(this.open),callback:function ($$v) {_vm.$set(this, "open", $$v)},expression:"this.open"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Gebruiker Toevoegen")]),_vm._v(" "),_c('v-card-text',[_c('v-text-field',{attrs:{"label":"Email","required":""},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Naam","required":""},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Telefoon","required":""},model:{value:(_vm.phone),callback:function ($$v) {_vm.phone=$$v},expression:"phone"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Password","type":"password","required":""},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"green--text darken-1",attrs:{"flat":"flat"},nativeOn:{"click":function($event){return _vm.closeModal($event)}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{staticClass:"green--text darken-1",attrs:{"flat":"flat"},nativeOn:{"click":function($event){return _vm.save($event)}}},[_vm._v("Save")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.c233d1c470baad400a08.js